<template>
  <div class="page_eleSigning">
    <div class="topOperation">
      <div class="top-left">
        <ShowNavHead />
        <div class="screenInputs" v-if="actFirstName != 'first'">
          <div class="screenInput">
            <div class="flname">姓名</div>
            <el-input v-model="listQuery.Name" size="small" clearable></el-input>
          </div>
          <div class="screenInput">
            <div class="flname" style="width: 85px;">手机号</div>
            <el-input v-model="listQuery.PhoneNum" size="small" clearable></el-input>
          </div>
          <div class="screenInput">
            <div class="flname" style="width: 85px;">项目名称</div>
            <el-select v-model="listQuery.ObjName" placeholder="" size="small" clearable filterable>
              <el-option v-for="item in proList" :key="item.Id" :label="item.StrprojectName" :value="item.StrprojectName"></el-option>
            </el-select>
          </div>
          <div class="screenInput">
            <el-tooltip class="scr_icon" effect="dark" content="高级检索项" placement="top-start">
              <i class="i_txt" @click="dropDownScreen">{{ showDropScreen == 1 ? '收起' : '更多' }}<i class="el-icon-caret-bottom"></i></i>
            </el-tooltip>
          </div>
        </div>
        <div class="screenInputs" v-if="actFirstName == 'first'">
          <div class="screenInput">
            <div class="flname">姓名</div>
            <el-input v-model="underQuery.strEmpName" size="small" clearable></el-input>
          </div>
          <div class="screenInput">
            <div class="flname">项目名称</div>
            <el-select v-model="underQuery.projectid" placeholder="" size="small" clearable filterable>
              <el-option label="全部" :value="0"></el-option>
              <el-option v-for="item in proList" :key="item.Id" :label="item.StrprojectName" :value="item.Projectid"></el-option>
            </el-select>
          </div>
        </div>
      </div>
      <div class="top-right">
        <el-button v-if="showDropScreen == -1 && actFirstName != 'first'" v-preventReClick type="success" size="small" @click="searchHandle" style="margin-right: 15px;">搜索</el-button>
        <el-button v-if="showDropScreen == -1 && actFirstName == 'first'" v-preventReClick type="success" size="small" @click="searchHandle1" style="margin-right: 15px;">搜索</el-button>
      </div>
    </div>
    <!-- 筛选下拉框 -->
    <div class="r_dropDownScreen" v-show="showDropScreen == 1">
      <div class="pro_down_box">
        <el-form :inline="true" :model="listQuery" class="re_down_form" label-width="95px">
          <el-form-item label="身份证号">
            <el-input v-model="listQuery.CardId" size="small" clearable></el-input>
          </el-form-item>
          <el-form-item :label="listQuery.SignatureStatus == '发起签约' ? '签约模板' : '合同名称'">
            <el-input v-model="listQuery.TempName" size="small" clearable></el-input>
          </el-form-item>
          <el-form-item label="主体名称">
            <el-select v-model="listQuery.ContractSubject" placeholder="" size="small" clearable filterable>
              <el-option v-for="(item, index) in legList" :key="index" :value="item.name"></el-option>
            </el-select>
          </el-form-item>
          <div>
            <el-form-item label="备注1" label-width="95px">
              <el-input v-model="listQuery.Remark1" size="small" clearable></el-input>
            </el-form-item>
            <el-form-item label="备注2">
              <el-input v-model="listQuery.Remark2" size="small" clearable></el-input>
            </el-form-item>
            <el-form-item label="备注3">
              <el-input v-model="listQuery.Remark3" size="small" clearable></el-input>
            </el-form-item>
          </div>
          <div>
            <el-form-item label="模板类型" v-if="listQuery.SignatureStatus == '发起签约'" size="small">
              <el-select v-model="listQuery.TempType" placeholder="" clearable filterable>
                <el-option value="用工协议"></el-option>
                <el-option value="证明文件"></el-option>
                <el-option value="其他"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="合同编号" v-if="listQuery.SignatureStatus != '发起签约'">
              <el-input v-model="listQuery.ContractId" size="small" clearable></el-input>
            </el-form-item>
            <el-form-item label="合同起始时间">
              <el-date-picker v-model="listQuery.ContractStartTime" type="date" value-format="yyyy-MM-dd" size="small" style="width:200px">
              </el-date-picker>
            </el-form-item>
            <el-form-item label="合同结束时间">
              <el-date-picker v-model="listQuery.ContractEndTime" type="date" value-format="yyyy-MM-dd" size="small" style="width:200px">
              </el-date-picker>
            </el-form-item>
          </div>
          <el-form-item label="地区">
            <el-input v-model="listQuery.WorkSite" size="small" clearable></el-input>
          </el-form-item>
          <div class="ApprovalTime" v-if="listQuery.SignatureStatus == '待审批'">
            <el-form-item label="员工签署起止时间">
              <div class="flex">
                <el-date-picker v-model="listQuery.EmpSigningStartTime" type="date" :picker-options="pickerOptions" @change="changeEmpSigningStartTime" value-format="yyyy-MM-dd" placeholder="选择开始时间"></el-date-picker>
                <el-date-picker style="margin-left: 20px;" v-model="listQuery.EmpSigninEndTime" type="date" :picker-options="setDateRange" value-format="yyyy-MM-dd" placeholder="选择结束时间"></el-date-picker>
              </div>
            </el-form-item>
          </div>
          <div class="ApprovalTime" v-if="listQuery.SignatureStatus == '通过' || listQuery.SignatureStatus == '已签约归档'">
            <el-form-item label="盖章起止时间">
              <div class="flex">
                <el-date-picker v-model="listQuery.ApprovalStartTime" type="date" @change="changeApprovalStartTime" :picker-options="pickerOptions" value-format="yyyy-MM-dd" placeholder="选择开始时间"></el-date-picker>
                <el-date-picker style="margin-left:20px;" v-model="listQuery.ApprovalEndTTime" type="date" :picker-options="setDateRange" value-format="yyyy-MM-dd" placeholder="选择结束时间"></el-date-picker>
              </div>
            </el-form-item>
          </div>
          <div class="ApprovalTime" v-if="listQuery.SignatureStatus == '逾期未签署'">
            <el-form-item label="发送开始时间">
              <el-date-picker v-model="listQuery.SendStartTime" type="date" value-format="yyyy-MM-dd" size="small" style="width:200px">
              </el-date-picker>
            </el-form-item>
            <el-form-item label="发送结束时间">
              <el-date-picker v-model="listQuery.SendEndTime" type="date" value-format="yyyy-MM-dd" size="small" style="width:200px">
              </el-date-picker>
            </el-form-item>
            <el-form-item label="逾期次数">
              <el-select v-model="listQuery.OverdueTimes" placeholder="" clearable filterable>
                <el-option v-for="item in 10" :key="item" :value="item"></el-option>
              </el-select>
            </el-form-item>
          </div>
          <div class="ApprovalTime" v-if="listQuery.SignatureStatus == '逾期未签署'">
            <el-form-item label="逾期开始时间">
              <el-date-picker v-model="listQuery.ContractUpdateBeginTime" type="date" value-format="yyyy-MM-dd" size="small" style="width:200px">
              </el-date-picker>
            </el-form-item>
            <el-form-item label="逾期结束时间">
              <el-date-picker v-model="listQuery.ContractUpdateEndTime" type="date" value-format="yyyy-MM-dd" size="small" style="width:200px">
              </el-date-picker>
            </el-form-item>
          </div>
        </el-form>
      </div>
      <div class="drop-footer">
        <el-button size="small" plain @click="resetHandle()">清空</el-button>
        <el-button size="small" type="info" plain @click="showDropScreen = -1">关闭</el-button>
        <el-button v-preventReClick size="small" type="success" @click="searchHandle()">搜索</el-button>
      </div>
    </div>
    <div class="main-con" v-loading="expLoading" element-loading-text="正在生成中" element-loading-spinner="el-icon-loading">
      <div class="crumbs2">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item>雇员</el-breadcrumb-item>
          <el-breadcrumb-item>电子签约</el-breadcrumb-item>
          <el-breadcrumb-item>合同审批</el-breadcrumb-item>
        </el-breadcrumb>
        <div class="tips">员工更改合同签约主体，请及时进行减员再增员（更换保险参保主体）。</div>
      </div>
      <el-tabs v-model="actFirstName" type="card" @tab-click="changeTab" v-if="roleName != '客户在线'">
        <el-tab-pane label="在职未签约" name="first"></el-tab-pane>
        <el-tab-pane :label="'发起签约（' + initNum + '）'" name="发起签约"></el-tab-pane>
        <el-tab-pane :label="'拒签（' + refuseNum + '）'" name="拒签"></el-tab-pane>
        <el-tab-pane :label="'逾期未签署（' + overdueNum + '）'" name="逾期未签署"></el-tab-pane>
        <el-tab-pane :label="'待员工签字（' + signedNum + '）'" name="待签字"></el-tab-pane>
        <el-tab-pane :label="'客服初审（' + firstApproveNum + '）'" name="客服初审"></el-tab-pane>
        <el-tab-pane :label="'待审批（' + approveNum + '）'" name="待审批"></el-tab-pane>
        <el-tab-pane :label="'驳回（' + notPassNum + '）'" name="不通过"></el-tab-pane>
        <el-tab-pane :label="'已签约（' + passNum + '）'" name="通过"></el-tab-pane>
        <el-tab-pane :label="'已签约归档（' + passNum2 + '）'" name="已签约归档"></el-tab-pane>
        <el-tab-pane :label="'已作废（' + delNum + '）'" name="删除"></el-tab-pane>
        <el-tab-pane :label="'线下签约（' + offineNum + '）'" name="线下签约"></el-tab-pane>
      </el-tabs>
      <el-tabs v-model="actFirstName" type="card" @tab-click="changeTab" v-if="roleName == '客户在线'">
        <el-tab-pane :label="'已签约（' + passNum + '）'" name="通过"></el-tab-pane>
      </el-tabs>
      <div class="ftabs">
        <div style="margin-bottom: 10px;" class="flex" v-if="actFirstName == 'first'">
          <el-button type="success" size="small" @click="enterSignHandle">&nbsp;签约</el-button>
          <el-button type="success" size="small" @click="batchOfflineSigning">&nbsp;线下登记签约</el-button>
          <el-button type="primary" size="small" @click="expList" :loading="isBtnLoading">&nbsp;导出</el-button>
          <el-button type="primary" size="small" @click="expAllList" :loading="isBtnAllLoading">&nbsp;全量导出</el-button>
        </div>
        <div style="margin-bottom: 10px;" class="flex" v-if="actFirstName != 'first'">
          <el-button type="primary" size="small" v-if="listQuery.SignatureStatus == '发起签约' && checkPermission(['eleSigning_import'], permissionLists)" @click="importSigning()">&nbsp;导入签约表</el-button>
          <el-button type="success" size="small" v-if="listQuery.SignatureStatus == '发起签约' && checkPermission(['eleSigning_send'], permissionLists)" @click="sendMessage('')">&nbsp;发送签约短信</el-button>
          <el-button type="success" size="small" v-if="(listQuery.SignatureStatus == '待签字' || listQuery.SignatureStatus == '逾期未签署' || listQuery.SignatureStatus == '拒签') && checkPermission(['eleSigning_send'], permissionLists)" @click="sendMessage('')">&nbsp;重新发送签约短信</el-button>

          <el-popover placement="top" width="160" v-model="visibleSendAll" v-if="(listQuery.SignatureStatus == '发起签约' || listQuery.SignatureStatus == '逾期未签署' || listQuery.SignatureStatus == '拒签') && checkPermission(['eleSigning_send'], permissionLists)">
            <p>请确认是否给{{ totalCount }}人发送短信？</p>
            <div style="text-align: right; margin: 0">
              <el-button size="mini" type="text" @click="visibleSendAll = false">取消</el-button>
              <el-button type="primary" v-preventReClick size="mini" @click="sendMessage('all')">确定</el-button>
            </div>
            <el-button slot="reference" type="warning" size="small" style="margin:0 10px">&nbsp;全员发送短信</el-button>
          </el-popover>

          <el-button type="success" size="small" v-if="listQuery.SignatureStatus == '发起签约' && checkPermission(['eleSigning_signing'], permissionLists)" @click="signing">&nbsp;单笔签约</el-button>
          <el-button type="primary" size="small" @click="exportList()" v-if="listQuery.SignatureStatus!='线下签约'">&nbsp;导出列表</el-button>
          <el-button type="success" size="small" @click="batchDel" v-if="(listQuery.SignatureStatus == '发起签约' || listQuery.SignatureStatus == '待签字') && checkPermission(['eleSigning_batchDel1'], permissionLists)">&nbsp;批量作废</el-button>
          <el-button type="success" size="small" @click="batchDel" v-if="(listQuery.SignatureStatus == '待审批' || listQuery.SignatureStatus == '通过' || listQuery.SignatureStatus == '不通过' || listQuery.SignatureStatus == '逾期未签署') && checkPermission(['eleSigning_batchDel2'], permissionLists)">&nbsp;批量作废</el-button>
          <el-button type="success" size="small" @click="exportContract" v-if="(listQuery.SignatureStatus == '通过' || listQuery.SignatureStatus == '已签约归档') && checkPermission(['eleSigning_exportContract'], permissionLists) && roleName != '客户在线'" :loading="isBtnLoading">&nbsp;批量导出合同</el-button>

          <el-button type="danger" size="small" v-if="roletype == '0383e791-72fd-4edc-aa70-2bcadminuser' && listQuery.SignatureStatus!='线下签约'" @click="exportProSum">&nbsp;导出项目签约汇总</el-button>
          <el-button type="warning" size="small" v-if="listQuery.SignatureStatus == '通过'" @click="batchPlacefileContracts">&nbsp;批量归档</el-button>
          <el-button type="warning" size="small" v-if="roletype == '0383e791-72fd-4edc-aa70-2bcadminuser' && listQuery.SignatureStatus!='线下签约'" @click="modelManage">&nbsp;批量导入模板管理</el-button>
        </div>
        <div v-if="actFirstName != 'first'">
          <el-table :data="tableData" border class="doc_table" v-loading="loading" :element-loading-text="progress >= 0 && progress != '' ? '发送短信中' + progress + '%' : ''" @selection-change="handleSelectionChange" :max-height="tableHeight - 180" style="width:100%">
            <el-table-column type="selection" width="40" fixed="left">
            </el-table-column>
            <el-table-column prop="Name" key="1" :label="listQuery.SignatureStatus == '发起签约' ? '姓名' : '签约人'" :show-overflow-tooltip="true" align="center" fixed="left">
            </el-table-column>
            <el-table-column prop="PhoneNum" key="2" :label="listQuery.SignatureStatus == '发起签约' ? '手机号' : '签约手机号'" :show-overflow-tooltip="true" align="center" width="110px">
            </el-table-column>
            <el-table-column prop="ObjName" key="3" label="项目" :show-overflow-tooltip="true" align="center" min-width="140px">
            </el-table-column>
            <el-table-column prop="JobName" key="4" label="岗位" :show-overflow-tooltip="true" align="center">
            </el-table-column>
            <el-table-column prop="StrIdCard" key="5" label="身份证号码" :show-overflow-tooltip="true" align="center" min-width="180px">
            </el-table-column>
            <el-table-column prop="UpdataTime" key="5.1" :show-overflow-tooltip="true" min-width="130" label="逾期时间" align="center" v-if="listQuery.SignatureStatus == '逾期未签署'">
              <template slot-scope={row}>{{ row.UpdataTime ? row.UpdataTime.replace('T', ' ') : ''}}
              </template>
            </el-table-column>
            <el-table-column prop="OverdueTimes" key="5.2" label="逾期次数" :show-overflow-tooltip="true" align="center" v-if="listQuery.SignatureStatus == '逾期未签署'">
            </el-table-column>
            <el-table-column prop="JobStatus" key="6" label="在职状态" align="center">
            </el-table-column>
            <el-table-column prop="TempName" key="7" label="签约模板" align="center" min-width="120px" :show-overflow-tooltip="true" v-if="listQuery.SignatureStatus == '发起签约'">
            </el-table-column>
            <el-table-column prop="TempType" key="8" label="模板类型" align="center" :show-overflow-tooltip="true" v-if="listQuery.SignatureStatus == '发起签约'">
            </el-table-column>
            <el-table-column prop="ProtocolType" key="9" label="合同/协议类型" align="center" :show-overflow-tooltip="true" width="130px">
            </el-table-column>
            <el-table-column prop="ContractSubject" key="10" label="签约主体" :show-overflow-tooltip="true" align="center" min-width="140px">
            </el-table-column>
            <el-table-column prop="TempName" key="11" label="合同名称" min-width="130" :show-overflow-tooltip="true" align="center" v-if="listQuery.SignatureStatus != '发起签约'">
            </el-table-column>
            <el-table-column prop="ContractId" key="12" label="合同编号" :show-overflow-tooltip="true" align="center" width="150" v-if="listQuery.SignatureStatus != '发起签约'">
            </el-table-column>
            <el-table-column prop="CreateTime" key="13" label="导入人员/时间" :show-overflow-tooltip="true" align="center" width="200" v-if="listQuery.SignatureStatus == '发起签约'">
              <template slot-scope={row}>
                {{ row.CreateTime ? row.ImportPersonName + '/' + row.CreateTime.replace('T', ' ') : row.ImportPersonName
                }}
              </template>
            </el-table-column>
            <el-table-column prop="ContractCreateTime" key="14" label="发送时间" align="center" width="150" v-if="listQuery.SignatureStatus == '逾期未签署' || listQuery.SignatureStatus == '待签字'">
              <template slot-scope={row}>
                {{ row.ContractCreateTime ? row.ContractCreateTime.replace('T', ' ') : '' }}
              </template>
            </el-table-column>
            <!-- <el-table-column prop="ContractCreateTime" label="合同生成时间" align="center" width="150" v-if="listQuery.SignatureStatus == '待审批' || listQuery.SignatureStatus == '通过'">
              <template slot-scope={row}>
                {{ row.ContractCreateTime ? row.ContractCreateTime.replace('T',' ') : '' }}
              </template>
            </el-table-column> -->
            <!-- <el-table-column prop="UpdataTime" label="最新操作时间" align="center" width="150" v-if="listQuery.SignatureStatus == '待审批'">
              <template slot-scope={row}>
                {{ row.UpdataTime ? row.UpdataTime.replace('T',' ') : '' }}
              </template>
            </el-table-column> -->
            <el-table-column prop="EmpSigningTime" key="15" label="员工签署时间" align="center" width="150" v-if="listQuery.SignatureStatus == '待审批'">
              <template slot-scope={row}>
                {{ row.EmpSigningTime ? row.EmpSigningTime.replace('T', ' ') : '' }}
              </template>
            </el-table-column>
            <el-table-column prop="FinishTime" key="16" label="员工签署时间" align="center" width="150" v-if="listQuery.SignatureStatus == '客服初审'">
            </el-table-column>
            <el-table-column prop="ApprovalTime" key="17" label="盖章时间" align="center" width="150" v-if="listQuery.SignatureStatus == '通过' || listQuery.SignatureStatus == '已签约归档'">
              <template slot-scope={row}>
                {{ row.ApprovalTime ? row.ApprovalTime.replace('T', ' ') : '' }}
              </template>
            </el-table-column>
            <el-table-column prop="ContractStartTime" key="18" label="合同起始日期" :show-overflow-tooltip="true" align="center" min-width="140px">
              <template slot-scope={row}>
                {{ row.ContractStartTime ? row.ContractStartTime.split('T')[0] : '' }}
              </template>
            </el-table-column>
            <el-table-column prop="ContractEndTime" key="19" label="合同结束日期" :show-overflow-tooltip="true" align="center" min-width="140px">
              <template slot-scope={row}>
                {{ row.ContractEndTime ? row.ContractEndTime.split('T')[0] : '' }}
              </template>
            </el-table-column>
            <el-table-column prop="ContractEndTime" key="19.5" label="合同时长" :show-overflow-tooltip="true" align="center" min-width="140px" v-if="listQuery.SignatureStatus == '发起签约'">
              <template slot-scope={row}>
                {{ getContractTime(row) }}
              </template>
            </el-table-column>
            <el-table-column prop="TrialPeriodStartTime" key="20" label="试用期起始时间" :show-overflow-tooltip="true" align="center" min-width="140px">
              <template slot-scope={row}>
                {{ row.TrialPeriodStartTime ? row.TrialPeriodStartTime.split('T')[0] : '' }}
              </template>
            </el-table-column>
            <el-table-column prop="TrialPeriodEndTime" key="21" label="试用期结束时间" :show-overflow-tooltip="true" align="center" min-width="140px">
              <template slot-scope={row}>
                {{ row.TrialPeriodEndTime ? row.TrialPeriodEndTime.split('T')[0] : '' }}
              </template>
            </el-table-column>
            <el-table-column prop="SourceContract" key="22" label="签约来源" :show-overflow-tooltip="true" align="center" width="150">
            </el-table-column>
            <el-table-column prop="StrEduLvl" key="23" label="文化程度" :show-overflow-tooltip="true" align="center" width="100">
            </el-table-column>
            <el-table-column prop="EmpContactAddress" key="24" label="联系地址" :show-overflow-tooltip="true" align="center" width="100">
            </el-table-column>
            <el-table-column prop="Bankcard" key="25" label="银行卡号" :show-overflow-tooltip="true" align="center" width="170">
            </el-table-column>
            <el-table-column prop="DepositBank" key="26" label="开户行" :show-overflow-tooltip="true" align="center" width="100">
            </el-table-column>
            <el-table-column prop="Gender" key="27" label="性别" align="center" width="100">
            </el-table-column>
            <el-table-column prop="StudentMajor" key="28" label="学生专业" :show-overflow-tooltip="true" align="center" width="100">
            </el-table-column>
            <el-table-column prop="SchoolName" key="29" label="学校名称" :show-overflow-tooltip="true" align="center" width="100">
            </el-table-column>
            <el-table-column prop="WorkingYearMonthDay" key="30" label="工作年月日" :show-overflow-tooltip="true" align="center" width="100">
            </el-table-column>
            <el-table-column prop="TimeLaborContract" key="31" label="终止(解除)劳动合同/协议时间" align="center" width="190">
              <template slot-scope={row}>
                {{ row.TimeLaborContract ? row.TimeLaborContract.split('T')[0] : '' }}
              </template>
            </el-table-column>
            <el-table-column prop="TimeLaborContractStaff" key="32" label="终止(解除)劳动合同/协议时间(员工联)" align="center" width="240">
              <template slot-scope={row}>
                {{ row.TimeLaborContractStaff ? row.TimeLaborContractStaff.split('T')[0] : '' }}
              </template>
            </el-table-column>
            <el-table-column prop="ShortNote" key="33" :label="listQuery.SignatureStatus == '拒签' ? '拒签原因' : '短信发送状态'" :show-overflow-tooltip="true" align="center" :width="listQuery.SignatureStatus == '拒签' ? '200' : '100'">
            </el-table-column>
            <el-table-column prop="EmpSigningTime" key="34" label="初审时间" align="center" width="150" v-if="listQuery.SignatureStatus == '通过' || listQuery.SignatureStatus == '已签约归档'">
              <template slot-scope={row}>
                {{ row.EmpSigningTime ? row.EmpSigningTime.replace('T',' ') : '' }}
              </template>
            </el-table-column>
            <el-table-column prop="ApprovalTime" key="35" label="终审时间" align="center" width="150" v-if="listQuery.SignatureStatus == '通过' || listQuery.SignatureStatus == '已签约归档'">
              <template slot-scope={row}>
                {{ row.ApprovalTime ? row.ApprovalTime.replace('T',' ') : '' }}
              </template>
            </el-table-column>
            <el-table-column prop="IsOnline" key="36" label="签约来源" align="center" v-if="listQuery.SignatureStatus == '通过' || listQuery.SignatureStatus == '已签约归档'" :show-overflow-tooltip="true" fixed="right" width="150">
              <template slot-scope={row}>
                {{ row.IsOnline ? row.IsOnline == '1' ? '线上签约' : '线下签约' : '' }}
              </template>
            </el-table-column>
            <el-table-column prop="FirstInstance" key="37" label="初审审批人" align="center" :show-overflow-tooltip="true" width="100">
            </el-table-column>
            <el-table-column prop="SecondInstance" key="38" label="终审审批人" align="center" :show-overflow-tooltip="true" width="100">
            </el-table-column>
            <el-table-column prop="WorkSite" label="地区" align="center" :show-overflow-tooltip="true" width="150">
            </el-table-column>
            <el-table-column prop="Remark1" label="备注1" align="center" :show-overflow-tooltip="true" width="150">
            </el-table-column>
            <el-table-column prop="Remark2" label="备注2" align="center" :show-overflow-tooltip="true" width="150">
            </el-table-column>
            <el-table-column prop="Remark3" label="备注3" align="center" :show-overflow-tooltip="true" width="150">
            </el-table-column>
            <el-table-column prop="ReturnReasons" label="驳回原因" align="center" v-if="listQuery.SignatureStatus == '不通过'" :show-overflow-tooltip="true" fixed="right" width="150">
            </el-table-column>
            <el-table-column prop="CustomeName" label="操作" align="center" :width="listQuery.SignatureStatus == '客服初审' ? '200px' : listQuery.SignatureStatus == '发起签约' || listQuery.SignatureStatus == '待审批' || listQuery.SignatureStatus == '待签字' ? '280px' : '160px'" fixed="right" v-if="(actFirstName == '发起签约' || actFirstName == '待签字' || actFirstName == '客服初审' || actFirstName == '逾期未签署' || actFirstName == '拒签') || ((actFirstName == '待审批' || actFirstName == '通过' || actFirstName == '不通过' || actFirstName == '已签约归档') && checkPermission(['eleSigning_batchDel2'], permissionLists))">
              <template slot-scope={row}>
                <div class="eleTabBtn">
                  <el-popconfirm :title="row.diffYear<1 ? row.Name + '的合同时长小于等于1年，请确定是否发送签约短信？' : '请确定是否给 ' + row.Name + ' 发送签约短信？'" @confirm="singleSendMessage(row)" v-if="listQuery.SignatureStatus == '发起签约' || listQuery.SignatureStatus == '逾期未签约'">
                    <el-button type="text" slot="reference" style="margin:0 10px;">发送短信</el-button>
                  </el-popconfirm>
                  <el-button type="text" @click="contractView2(row)" v-if="listQuery.SignatureStatus == '发起签约'">合同预览</el-button>
                  <el-button type="text" @click="editPhone(row)" v-if="listQuery.SignatureStatus == '发起签约' || listQuery.SignatureStatus == '待签字'" style="margin-left: 10px;">修改手机号</el-button>
                  <!-- <el-button type="text" @click="dtlHandle(row)" v-if="listQuery.SignatureStatus == '待签字'">查看</el-button> -->
                  <el-button type="text" @click="downContract(row, 'preview')" v-preventReClick v-if="listQuery.SignatureStatus == '待签字' || listQuery.SignatureStatus == '待审批' || listQuery.SignatureStatus == '客服初审' || listQuery.SignatureStatus == '通过' || listQuery.SignatureStatus == '已签约归档'">合同预览</el-button>

                  <el-button type="text" @click="placefileContracts(row.Id)" v-preventReClick v-if="listQuery.SignatureStatus == '通过'">归档</el-button>

                  <el-button type="text" style="margin-left: 10px;" @click="downContract(row, 'down')" v-preventReClick v-if="listQuery.SignatureStatus == '待审批' || listQuery.SignatureStatus == '通过' || listQuery.SignatureStatus == '待签字' || listQuery.SignatureStatus == '客服初审' || listQuery.SignatureStatus == '已签约归档'">下载</el-button>

                  <!-- <el-button type="text" style="margin-left: 10px;" @click="inspect(row)" >审批</el-button> -->

                  <el-popconfirm :title="'请确定 ' + row.Name + '是否通过审批？'" @confirm="pass(row, '1')" v-if="listQuery.SignatureStatus == '待审批' && checkPermission(['eleSigning_inspect'], permissionLists)">
                    <el-button type="text" slot="reference" style="margin-left: 10px;">通过</el-button>
                  </el-popconfirm>

                  <!-- <el-popconfirm :title="'请确定是否驳回' + row.Name + '？'" @confirm="pass(row,'0')" v-if="listQuery.SignatureStatus == '待审批' &&  checkPermission(['eleSigning_inspect'],permissionLists)">
                    <el-button type="text" slot="reference" style="margin-left: 10px;">驳回</el-button>
                  </el-popconfirm> -->
                  <el-button type="text" v-if="listQuery.SignatureStatus == '待审批' && checkPermission(['eleSigning_inspect'], permissionLists)" style="margin-left: 10px;" @click="reject(row)">驳回</el-button>


                  <!-- <el-button type="text" style="margin-left: 10px;" @click="firstInspect(row)" v-if="listQuery.SignatureStatus == '客服初审'">初审</el-button> -->
                  <el-popconfirm :title="'请确定 ' + row.Name + '是否通过初审？'" @confirm="firstInspect(row)" v-if="listQuery.SignatureStatus == '客服初审'">
                    <el-button type="text" slot="reference" style="margin-left: 10px;" v-if="listQuery.SignatureStatus == '客服初审'">初审</el-button>
                  </el-popconfirm>


                  <el-popconfirm :title="'请确定 ' + row.Name + ' 的签约作废 ？'" @confirm="delHandle(row)" v-if="listQuery.SignatureStatus != '通过'">
                    <el-button type="text" slot="reference" style="margin-left: 10px;">作废</el-button>
                  </el-popconfirm>
                </div>
              </template>
            </el-table-column>
            <el-table-column label="操作" align="center" v-if="roleName == '客户在线'" fixed="right">
              <template slot-scope={row}>
                <div class="eleTabBtn">
                  <el-button type="text" @click="downContract(row, 'preview')" v-preventReClick>合同预览</el-button>
                </div>
              </template>
            </el-table-column>
            <el-table-column label="操作" align="center" v-if="actFirstName == '线下签约'" fixed="right">
              <template slot-scope={row}>
                <div class="eleTabBtn">
                  <el-button type="text" @click="downOffineContract(row)" v-preventReClick v-if="row.AttachUrl">下载</el-button>
                </div>
              </template>
            </el-table-column>
          </el-table>
          <div class="block">
            <el-pagination v-if="totalCount > 0" @current-change="currentChange" :current-page.sync="listQuery.pageNum" :page-size="Number(listQuery.pageSize)" @size-change="handleSizeChange" :page-sizes="[10, 20, 50, 100, 200]" layout="total,sizes,prev,pager, next, jumper" :total="totalCount"></el-pagination>
          </div>
        </div>
        <!-- 在职未签约模块 -->
        <div v-if="actFirstName == 'first'">
          <el-table ref="multipleTable" class="re_table" v-loading="tableLoading" :max-height="tableHeight - 180" :highlight-current-row="true" @selection-change="underSelChange" :data="notUnderData" style="width:100%">
            <el-table-column type="selection" align="center" width="55" label-class-name="com_Selection"></el-table-column>
            <template v-for="(item, index) in tableTitle">
              <el-table-column :prop="item.StrColumId" :label="item.StrColumName" fit :show-overflow-tooltip="true" :key="index + 'A'" :min-width="item.StrColumName.indexOf('序号') > -1 || item.StrColumName.indexOf('性别') > -1 || item.StrColumName.indexOf('年龄') > -1 || item.StrColumName.indexOf('籍贯') > -1 ? '50px' : item.StrColumName.indexOf('项目名称') > -1 || item.StrColumName.indexOf('客户名称') > -1 || item.StrColumName.indexOf('原因') > -1 || item.StrColumName.indexOf('地') > -1 || item.StrColumName.indexOf('时间') > -1 ? '170px' : '110px'" align="center" :fixed="item.StrColumName == '序号' || item.StrColumName == '姓名' || item.StrColumName == '联系方式'">
                <template slot-scope="{row}">
                  <span v-if="item.StrColumId == 'StrUserName' && row.sendtype == '1'" class="send_icon">
                    {{ isNull(row[item.StrColumId]) ? '' : row[item.StrColumId] }}
                  </span>
                  <i v-if="item.StrColumId == 'StrUserName' && row.sendtype == '1'" class="el-icon-s-comment"></i>
                  <span v-else-if="item.StrColumName == '入职时间'">{{ isNull(row[item.StrColumId]) ? '' :
                    row[item.StrColumId].replace('T', ' ') }}</span>
                  <span v-else-if="item.StrColumName.indexOf('在职天数') > -1">{{ isMinus(row[item.StrColumId]) ? '0' :
                    row[item.StrColumId] }}</span>
                  <span v-else>{{ isNull(row[item.StrColumId]) ? '' : row[item.StrColumId] }}</span>
                </template>
              </el-table-column>
            </template>
            <el-table-column prop="EmpSigningTime" label="盖章时间" :show-overflow-tooltip="true" align="center" min-width="140px">
            </el-table-column>
            <el-table-column align="center" width="100" fixed="right" label="操作">
              <template slot-scope={row}>
                <div class="eleTabBtn">
                  <el-button type="text" size="small" @click="OfflineSigning(row)">线下签约登记</el-button>
                </div>
              </template>
            </el-table-column>
          </el-table>
          <div class="block">
            <el-pagination @current-change="underCurrentChange" :current-page.sync="underQuery.pagination.page" :page-size="underQuery.pagination.pageSize" @size-change="underSizeChange" :page-sizes="[10, 20, 50, 100, 200]" layout="total,sizes,prev,pager,next,jumper" :total="underTotal"></el-pagination>
          </div>
        </div>
      </div>
    </div>

    <div>
      <el-dialog title="发送签约短信" :visible.sync="showSendMessage" width="1000px">
        <el-table :data="multipleSelection" border class="ele_table" style="width:100%" max-height="500px">
          <el-table-column label="序号" width="50">
            <template slot-scope="scope">
              {{ scope.$index + 1 }}
            </template>
          </el-table-column>
          <el-table-column prop="Name" label="姓名" :show-overflow-tooltip="true" align="center" min-width="80">
          </el-table-column>
          <el-table-column prop="PhoneNum" label="电话" :show-overflow-tooltip="true" align="center" min-width="110">
          </el-table-column>
          <el-table-column prop="StrIdCard" label="身份证号码" :show-overflow-tooltip="true" align="center" min-width="160">
          </el-table-column>
          <el-table-column prop="ObjName" label="项目名称" :show-overflow-tooltip="true" align="center" min-width="160">
          </el-table-column>
          <el-table-column prop="JobName" label="岗位" :show-overflow-tooltip="true" align="center" min-width="100">
          </el-table-column>
          <el-table-column prop="ContractSubject" label="签约主体" :show-overflow-tooltip="true" align="center" min-width="100">
          </el-table-column>
          <el-table-column prop="TempName" label="合同模板" :show-overflow-tooltip="true" align="center" min-width="160">
          </el-table-column>
          <el-table-column prop="ContractStartTime" label="合同开始日期" :show-overflow-tooltip="true" align="center" min-width="100px">
            <template slot-scope={row}>
              {{ row.ContractStartTime ? row.ContractStartTime.split('T')[0] : '' }}
            </template>
          </el-table-column>
          <el-table-column prop="ContractEndTime" label="合同结束日期" :show-overflow-tooltip="true" align="center" min-width="100px">
            <template slot-scope={row}>
              {{ row.ContractEndTime ? row.ContractEndTime.split('T')[0] : '' }}
            </template>
          </el-table-column>
          <el-table-column prop="EmergencyPhone" label="紧急联系人" :show-overflow-tooltip="true" align="center" min-width="100">
          </el-table-column>
          <el-table-column prop="EmergencyContact" label="紧急联系人电话" :show-overflow-tooltip="true" align="center" min-width="120px">
          </el-table-column>
        </el-table>
        <span slot="footer" class="dialog-footer">
          <el-button @click="showSendMessage = false" size="small">取消</el-button>
          <el-button type="primary" v-preventReClick size="small" @click="confirmSend">确定</el-button>
        </span>
      </el-dialog>

      <el-dialog title="批量作废" :visible.sync="showBatchDel" width="1000px">
        <el-form label-width="80px">
          <el-form-item label="作废原因">
            <el-input v-model="DeleteReason" size="small" style="width:300px"></el-input>
          </el-form-item>
        </el-form>
        <el-table :data="multipleSelection" class="ele_table" style="width:100%" max-height="500px">
          <el-table-column label="序号" width="50">
            <template slot-scope="scope">
              {{ scope.$index + 1 }}
            </template>
          </el-table-column>
          <el-table-column prop="Name" label="姓名" :show-overflow-tooltip="true" align="center" width="80">
          </el-table-column>
          <el-table-column prop="PhoneNum" label="电话" :show-overflow-tooltip="true" align="center" min-width="110">
          </el-table-column>
          <el-table-column prop="StrIdCard" label="身份证号码" :show-overflow-tooltip="true" align="center" min-width="160">
          </el-table-column>
          <el-table-column prop="ObjName" label="项目名称" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="JobName" label="岗位" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="ContractSubject" label="签约主体" :show-overflow-tooltip="true" align="center" min-width="100">
          </el-table-column>
          <el-table-column prop="TempName" label="合同模板" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="ContractStartTime" label="合同开始日期" :show-overflow-tooltip="true" align="center" min-width="100px">
            <template slot-scope={row}>
              {{ row.ContractStartTime ? row.ContractStartTime.split('T')[0] : '' }}
            </template>
          </el-table-column>
          <el-table-column prop="ContractEndTime" label="合同结束日期" :show-overflow-tooltip="true" align="center" min-width="100px">
            <template slot-scope={row}>
              {{ row.ContractEndTime ? row.ContractEndTime.split('T')[0] : '' }}
            </template>
          </el-table-column>
          <el-table-column prop="EmergencyPhone" label="紧急联系人" :show-overflow-tooltip="true" align="center" min-width="100">
          </el-table-column>
          <el-table-column prop="EmergencyContact" label="紧急联系人电话" :show-overflow-tooltip="true" align="center" min-width="120px">
          </el-table-column>
        </el-table>
        <span slot="footer" class="dialog-footer">
          <el-button @click="showBatchDel = false" size="small">取消</el-button>
          <el-button type="primary" v-preventReClick size="small" @click="confirmBatchDel">确定</el-button>
        </span>
      </el-dialog>

      <div class="inspect">
        <el-dialog title="审批确认" :visible.sync="showInspect" width="600px">
          <el-form :model="info" :inline="true" label-width="110px">
            <el-form-item label="姓名：">
              <div class="inspectItem">{{ info.Name }}</div>
            </el-form-item>
            <el-form-item label="身份证：">
              <div class="inspectItem">{{ info.StrIdCard }}</div>
            </el-form-item>
            <el-form-item label="电话：">
              <div class="inspectItem">{{ info.PhoneNum }}</div>
            </el-form-item>
            <el-form-item label="项目：">
              <div class="inspectItem">{{ info.ObjName }}</div>
            </el-form-item>
            <el-form-item label="岗位：">
              <div class="inspectItem">{{ info.JobName }}</div>
            </el-form-item>
            <div>
              <el-form-item label="合同开始日期：">
                <div class="inspectItem">{{ info.ContractStartTime ? info.ContractStartTime.split('T')[0] : '' }}</div>
              </el-form-item>
              <el-form-item label="合同结束日期：">
                <div class="inspectItem">{{ info.ContractEndTime ? info.ContractEndTime.split('T')[0] : '' }}</div>
              </el-form-item>
            </div>
            <div class="inspect_foot">
              <el-button type="danger" v-preventReClick @click="pass('0')">审核不通过</el-button>
              <el-button type="success" v-preventReClick @click="pass('1')">审核通过</el-button>
            </div>
          </el-form>
        </el-dialog>
      </div>

      <div class="eleForm">
        <el-dialog title="导入签约表" :visible.sync="showImport" width="1060px">
          <el-form :model="importForm" :inline="true" :rules="importRules" ref="importForm" label-width="130px">
            <el-form-item label="项目名称" prop="ObjName">
              <el-select v-model="importForm.ObjName" placeholder="" clearable filterable style="width:200px" @change="changePro" size="small">
                <el-option v-for="item in proList" :key="item.Id" :label="item.StrprojectName" :value="item.StrprojectName"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="签约模板" prop="tempid">
              <el-select v-model="tempName" placeholder="" clearable filterable style="width:200px" value-key="TempName" :disabled="!importForm.ObjName" size="small" @change="changeTemp">
                <el-option v-for="(item, index) in tempList" :key="index" :label="item.TempName" :value="item"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="合同/协议类型" prop="ProtocolType">
              <el-select v-model="importForm.ProtocolType" value-key="name" placeholder="" @change="changeNo" clearable filterable size="small" style="width:200px">
                <el-option v-for="(item, index) in contractList" :key="index" :label="item.name" :value="item"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="员工签约主体" prop="ContractSubject">
              <el-select v-model="importForm.ContractSubject" placeholder="" clearable filterable style="width:320px" size="small" @change="(val) => { changeLeg(val, 'importForm') }">
                <el-option v-for="(item, index) in legList" :key="index" :value="item.name"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="法人" label-width="70px" prop="LegalPer" v-if="importForm.ProtocolType != '其他'">
              <el-input v-model="importForm.LegalPer" readonly style="width:140px" disabled size="small"></el-input>
            </el-form-item>
            <el-form-item label="注册地址" prop="RegisterAddress" v-if="importForm.ProtocolType != '其他'">
              <el-input v-model="importForm.RegisterAddress" readonly style="width:200px" disabled size="small"></el-input>
            </el-form-item>
            <el-form-item label="统一社会信用代码" prop="TaxNum" v-if="contractType<8">
              <el-input v-model="importForm.TaxNum" readonly style="width:200px" disabled size="small"></el-input>
            </el-form-item>
            <el-form-item label="客户单位全称">
              <el-input v-model="importForm.ClientFullName" style="width:200px" size="small"></el-input>
            </el-form-item>
            <el-form-item label="报税地" v-if="contractType<8">
              <el-input v-model="importForm.TaxCity" style="width:200px" size="small"></el-input>
            </el-form-item>
            <el-form-item :label="no!=30 ? '发薪日' : '发放日'" v-if="contractType!=8 && contractType!=9 && contractType!=10 && no!=31">
              <el-input v-model="importForm.PayDay" style="width:200px" size="small"></el-input>
            </el-form-item>

            <el-form-item label="工资标准方式" v-if="contractType!=8 && contractType!=9 && contractType!=10 && no!=30 && no!=31">
              <el-select v-model="importForm.MeansOfPayments" placeholder="" clearable filterable size="small" style="width:200px">
                <el-option value="0" label="固定工资" size="small"></el-option>
                <el-option value="1" label="基本工资+绩效工资" size="small"></el-option>
                <el-option value="2" label="计件工资" size="small"></el-option>
              </el-select>
            </el-form-item>

            <el-form-item label="工资" v-if="contractType!=8 && contractType!=9 && contractType!=10 && no!=2 && no!=30 && no!=31 && no!=35 && no!=36">
              <el-input v-model="importForm.Yuan" style="width:200px" size="small"></el-input>
            </el-form-item>

            <!-- <el-form-item label="城市" v-if="no == 23">
              <el-input v-model="importForm.WorkCity" style="width:200px" size="small"></el-input>
            </el-form-item>

            <el-form-item label="工时" v-if="no == 23">
              <el-select v-model="importForm.WorkTime" placeholder="" clearable filterable size="small" style="width:200px">
                <el-option label="标准工时制" value="0"></el-option>
                <el-option label="不定时工时制" value="1"></el-option>
                <el-option label="综合计算工时制" value="2"></el-option>
              </el-select>
            </el-form-item> -->

            <el-form-item label="导入Excel" prop="url">
              <div class="file-box">
                <input readonly style="width: 200px;height:32px;margin-top: 4px;" id="applyLicense" type="text" v-model="ExcelSrc.fileName" autocomplete="off">
                <input id="fileInput" type="file" name="file" accept=".xlsx,.xls" @change="importf(this)" ref="upload">
                <label for="fileInput" class="file-btn cp">上传</label>
              </div>
            </el-form-item>
            <div>
              <el-form-item label="导入模板">
                <el-button type="text" class="blueName cp" @click="downImportTemp">下载模板</el-button>
                <div style="width: 200px;"></div>
              </el-form-item>
              <el-form-item label="合同预览" v-if="this.shangTempId">
                <el-button type="text" class="blueName cp" @click="review">合同预览</el-button>
              </el-form-item>
            </div>
          </el-form>
          <div class="tips" v-if="no==30">服务内容:不可直接写岗位，需根据参保岗位，倒推服务内容:(如保安岗位:安保服务保洁岗位:清洁服务;等)如有疑问可与上级主管确认。</div>
          <span slot="footer" class="dialog-footer">
            <el-button @click="showImport = false" size="small">取 消</el-button>
            <el-button type="primary" :disabled="!isUploadSuccess || !importForm.url" v-preventReClick style="margin-left:10px;" @click="confirmImport" :loading="impLoading" size="small">提 交</el-button>
          </span>
        </el-dialog>

        <el-dialog title="单笔签约" :visible.sync="showSigning" width="1060px">
          <el-form :model="signingForm" :inline="true" ref="signingForm" :rules="importRules" label-width="130px">
            <el-form-item label="项目名称" prop="ObjName">
              <el-select v-model="signingForm.ObjName" placeholder="" clearable filterable style="width:200px" @change="changePro" size="small">
                <el-option v-for="item in proList" :key="item.Id" :label="item.StrprojectName" :value="item.StrprojectName"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="签约模板" prop="tempid">
              <el-select v-model="tempNameSingle" placeholder="" clearable filterable style="width:200px" value-key="TempId" :disabled="!signingForm.ObjName" size="small" @change="changeTempSingle">
                <el-option v-for="(item, index) in tempList" :key="index" :label="item.TempName" :value="item"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="合同/协议类型" prop="ProtocolType">
              <el-select v-model="signingForm.ProtocolType" value-key="name" placeholder="" clearable filterable size="small" @change="(val) => { changeCont(val, 'signingForm') }" style="width:200px">
                <el-option v-for="(item, index) in contractList" :key="index" :label="item.name" :value="item"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="合同预览" v-if="this.shangTempId">
              <div style="width: 200px;">
                <el-button type="text" class="blueName cp" @click="review">合同预览</el-button>
              </div>
            </el-form-item>
            <el-form-item label="姓名" prop="list[0].name">
              <el-input v-model="signingForm.list[0].name" style="width:200px" size="small"></el-input>
            </el-form-item>
            <el-form-item label="电话" prop="list[0].PhoneNum">
              <el-input v-model.trim="signingForm.list[0].PhoneNum" style="width:200px" size="small"></el-input>
            </el-form-item>
            <el-form-item label="身份证" :prop="(contractType != 11 || no == 25) ? 'list[0].StrIdCard' : ''">
              <el-input v-model.trim="signingForm.list[0].StrIdCard" style="width:200px" size="small" @blur="getContTime(signingForm.list[0].StrIdCard,'signingForm')"></el-input>
            </el-form-item>
            <el-form-item label="性别" prop="list[0].Gender" v-if="no==32">
              <el-select v-model="signingForm.list[0].Gender" placeholder="" clearable filterable style="width:200px" size="small">
                <el-option value="男"></el-option>
                <el-option value="女"></el-option>
              </el-select>
            </el-form-item>

            <el-form-item label="员工签约主体" prop="ContractSubject">
              <el-select v-model="signingForm.ContractSubject" placeholder="" clearable filterable style="width:320px" size="small" @change="(val) => { changeLeg(val, 'signingForm') }">
                <el-option v-for="(item, index) in legList" :key="index" :value="item.name"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="法人" label-width="70px" prop="LegalPer" v-if="contractType != 11">
              <el-input v-model="signingForm.LegalPer" readonly style="width:140px" disabled size="small"></el-input>
            </el-form-item>
            <el-form-item label="注册地址" prop="RegisterAddress" v-if="contractType != 11">
              <el-input v-model="signingForm.RegisterAddress" readonly style="width:200px" disabled size="small"></el-input>
            </el-form-item>
            <el-form-item label="统一社会信用代码" prop="TaxNum" v-if="contractType<8">
              <el-input v-model="signingForm.TaxNum" readonly style="width:200px" disabled size="small"></el-input>
            </el-form-item>
            <el-form-item label="报税地" v-if="contractType<8">
              <el-input v-model="signingForm.TaxCity" style="width:200px" size="small"></el-input>
            </el-form-item>

            <el-form-item :label="jobNameLabel" prop="list[0].JobName" v-if="contractType != 1 && contractType != 9 && contractType != 10 && contractType != 11 && contractType != 12 && contractType">
              <el-input v-model="signingForm.list[0].JobName" style="width:200px" size="small"></el-input>
            </el-form-item>

            <el-form-item label="工作地点(区域)" prop="WorkSite" v-if="(contractType == 5 || contractType == 6) && no!=28 && no!=33">
              <el-input v-model="signingForm.WorkSite" style="width:200px" size="small"></el-input>
            </el-form-item>

            <el-form-item label="学校全称" prop="SchoolName" v-if="(contractType == 3 || contractType == 9) && no!=29 && no!=32 && no!=33">
              <el-input v-model="signingForm.SchoolName" style="width:200px" size="small"></el-input>
            </el-form-item>

            <el-form-item label="学生专业" v-if="contractType == 9">
              <el-input v-model="signingForm.StudentMajor" style="width:200px" size="small"></el-input>
            </el-form-item>

            <el-form-item label="入职日期" :prop="contractType == 8 || contractType == 9 || contractType == 10 ? '' : 'list[0].DtEntryBdate'" v-if="contractType != 11 && contractType != 12 && no!=24 && no!=26 && no!=27 && no!=28 && no!=29 && no!=32 && no!=33">
              <el-date-picker type="date" placeholder="" v-model="signingForm.list[0].DtEntryBdate" value-format="yyyy-MM-dd" style="width:200px" size="small" @blur="changeTimeLaborContract('signingForm', val)"></el-date-picker>
            </el-form-item>

            <el-form-item label="文化程度" prop="list[0].StrEduLvl" v-if="contractType && contractType < 8  && no!=24 && no!=28 && no!=29 && no!=32 && no!=33">
              <el-input v-model="signingForm.list[0].StrEduLvl" style="width:200px" size="small"></el-input>
            </el-form-item>

            <el-form-item label="联系地址" prop="list[0].EmpContactAddress" v-if="contractType && contractType < 8  && no!=24 && no!=29">
              <el-input v-model="signingForm.list[0].EmpContactAddress" style="width:200px" size="small"></el-input>
            </el-form-item>

            <el-form-item label="客户单位全称" v-if="no!=24 && no!=25 && no!=26 && no!=27 && no!=28 && no!=29">
              <el-input v-model="signingForm.list[0].ClientFullName" style="width:200px" size="small"></el-input>
            </el-form-item>

            <el-form-item :label="contractType != 9 || contractType != 10 ? '合同起始时间' : '协议起始时间'" prop="ContractStartTime" v-if="contractType != 9 && contractType != 10 && contractType != 11 && contractType">
              <el-date-picker type="date" placeholder="" v-model="signingForm.ContractStartTime" value-format="yyyy-MM-dd" style="width:200px" size="small"></el-date-picker>
            </el-form-item>
            <el-form-item v-if="contractType != 9 && contractType != 10 && contractType != 11 && contractType != 12 && contractType != 13 && contractType && no!=26 && no!=33">
              <template #label>
                <span v-if="contractType != 9 || contractType != 10">合同时长<span style="color:red">{{ no==30 ? '（月）' : '（年）'}}</span></span>
                <span v-else>协议时长（<span style="color:red">{{ no==30 ? '（月）' : '（年）'}}</span>）</span>
              </template>
              <el-input type="number" v-model="ContractTime" @blur="getContractEndDate(ContractTime,'signingForm')" style="width:200px" size="small" :disabled="!signingForm.ContractStartTime"></el-input>
            </el-form-item>
            <el-form-item v-if="no==33">
              <template #label>
                <span>合同时长（<span style="color:red">月</span>）</span>
              </template>
              <el-input type="number" v-model="signingForm.WorkingMonth" @blur="getContractEndDate(signingForm.WorkingMonth,'signingForm')" style="width:200px" size="small" :disabled="!signingForm.ContractStartTime"></el-input>
            </el-form-item>
            <el-form-item :label="contractType != 9 || contractType != 10 ? '合同结束时间 （可编辑更改）' : '协议结束时间 （可编辑更改）'" prop="ContractEndTime" v-if="contractType != 9 && contractType != 10 && contractType != 11 && contractType != 13 && no != 22 && contractType && no!=26">
              <el-date-picker type="date" placeholder="" v-model="signingForm.ContractEndTime" value-format="yyyy-MM-dd" style="width:200px" size="small"></el-date-picker>
            </el-form-item>
            <el-form-item label="合同结束时间" v-if="contractType == 13 || no == 22">
              <el-input v-model="noDateTxt" style="width:200px" size="small" readonly disabled></el-input>
            </el-form-item>
            <el-form-item label="试用期起始时间" prop="TrialPeriodStartTime" v-if="contractType == 1 || contractType == 2 || contractType == 5 || contractType == 7">
              <el-date-picker type="date" placeholder="" v-model="signingForm.TrialPeriodStartTime" value-format="yyyy-MM-dd" style="width:200px" size="small"></el-date-picker>
            </el-form-item>
            <el-form-item label="试用期时长（月）" prop="TrialMonth" v-if="contractType == 1 || contractType == 2 || contractType == 5 || contractType == 7">
              <el-input type="number" v-model="signingForm.TrialMonth" style="width:200px" size="small" :disabled="!signingForm.TrialPeriodStartTime" @blur="getEndDate('signingForm')"></el-input>
            </el-form-item>
            <el-form-item label="试用期结束时间（可编辑更改）" prop="TrialPeriodEndTime" v-if="contractType == 1 || contractType == 2 || contractType == 5 || contractType == 7">
              <el-date-picker type="date" placeholder="" v-model="signingForm.TrialPeriodEndTime" value-format="yyyy-MM-dd" style="width:200px" size="small"></el-date-picker>
            </el-form-item>

            <el-form-item :label="contractType == 8 ? '终止（解除）劳动合同时间' : '终止（解除）协议时间'" prop="TimeLaborContract" v-if="contractType == 8 || contractType == 9 || contractType == 10 || contractType == 12 || contractType == 13">
              <el-date-picker type="date" placeholder="" v-model="signingForm.TimeLaborContract" value-format="yyyy-MM-dd" style="width:200px" size="small" @change="val => { changeTimeLaborContract('signingForm', val) }"></el-date-picker>
            </el-form-item>

            <el-form-item label="工作时长(年)" prop="WorkingYear" v-if="(contractType == 8 || contractType == 13) && no!=26">
              <el-input v-model="signingForm.WorkingYear" style="width:200px" size="small"></el-input>
            </el-form-item>
            <el-form-item label="工作时长(月)" prop="WorkingMonth" v-if="(contractType == 8 || contractType == 13) && no!=26">
              <el-input v-model="signingForm.WorkingMonth" style="width:200px" size="small"></el-input>
            </el-form-item>
            <el-form-item label="工作时长(天)" prop="WorkingDay" v-if="(contractType == 8 || contractType == 13) && no!=26">
              <el-input v-model="signingForm.WorkingDay" style="width:200px" size="small"></el-input>
            </el-form-item>

            <el-form-item :label="contractType == 8 ? '终止（解除）劳动合同时间（员工联）' : '终止（解除）协议时间（员工联）'" prop="TimeLaborContractStaff" v-if="(contractType == 8 || contractType == 9 || contractType == 10 || contractType == 12 || contractType == 13) && no!=26">
              <el-date-picker type="date" placeholder="" v-model="signingForm.TimeLaborContractStaff" value-format="yyyy-MM-dd" style="width:200px" size="small"></el-date-picker>
            </el-form-item>

            <el-form-item label="银行卡号" v-if="contractType != 11 && contractType != 12 && contractType != 13 && no!=24 && no!=26 && no!=32 && no!=33" :prop="no==28 || no==29 ? 'list[0].Bankcard' : ''">
              <el-input v-model="signingForm.list[0].Bankcard" style="width:200px" size="small"></el-input>
            </el-form-item>

            <el-form-item label="开户银行" v-if="contractType != 11 && contractType != 12 && contractType != 13 && no!=24 && no!=26 && no!=32 && no!=33" :prop="no==28 || no==29 ? 'list[0].DepositBank' : ''">
              <el-input v-model="signingForm.list[0].DepositBank" style="width:200px" size="small"></el-input>
            </el-form-item>


            <el-form-item :label="no!=30 ? '发薪日' : '发放日'" v-if="contractType != 8 && contractType != 9 && contractType != 10 && contractType != 12 && contractType != 13 && no!=25 && no!=24 && no!=26 && no!=27 && no!=28 && no!=29 && no!=31">
              <el-input v-model="signingForm.PayDay" style="width:200px" size="small"></el-input>
            </el-form-item>

            <el-form-item label="工资标准方式" v-if="contractType != 8 && contractType != 9 && contractType != 10 && contractType != 12 && contractType != 13 && no!=25 && no!=26 && no!=28 && no!=29 && no!=30 && no!=31 && no!=32 && no!=33">
              <el-select v-model="signingForm.MeansOfPayments" placeholder="" clearable filterable size="small" style="width:200px">
                <el-option value="0" label="固定工资"></el-option>
                <el-option value="1" label="基本工资+绩效工资"></el-option>
                <el-option value="2" label="计件工资"></el-option>
              </el-select>
            </el-form-item>

            <el-form-item label="工资" v-if="contractType != 8 && contractType != 9 && contractType != 10 && contractType != 12 && contractType != 13 && no!=25 && no!=26 && no!=30 && no!=31 && no!=33 && no!=33" :prop="no==24 || no==27 || no==28 || no==29 || no==35 || no==36 ? 'Yuan' : ''">
              <el-input v-model="signingForm.Yuan" type="number" style="width:200px" size="small"></el-input>
            </el-form-item>


            <el-form-item label="月岗位工资" v-if="no == 33 || no == 34" prop="list[0].StrInterDurMonths">
              <el-input v-model="signingForm.list[0].StrInterDurMonths" style="width:200px" size="small"></el-input>
            </el-form-item>

            <el-form-item label="月绩效工资" v-if="no == 33 || no == 34" prop="list[0].StrReasonLeaving">
              <el-input v-model="signingForm.list[0].StrReasonLeaving" style="width:200px" size="small"></el-input>
            </el-form-item>

            <el-form-item label="税前基本工资" v-if="no==32">
              <el-input v-model="signingForm.list[0].StrWorkHours" style="width:200px" size="small"></el-input>
            </el-form-item>

            <el-form-item label="税前月岗位津贴" v-if="no==32">
              <el-input v-model="signingForm.list[0].StrInterDurMonths" style="width:200px" size="small"></el-input>
            </el-form-item>

            <el-form-item label="城市" v-if="no == 23 || no == 2">
              <el-input v-model="signingForm.WorkCity" style="width:200px" size="small"></el-input>
            </el-form-item>

            <el-form-item label="工时" v-if="no == 23 || no == 24 || no == 27" :prop="no=='24' || no==27 ? 'WorkTime' : ''">
              <el-select v-model="signingForm.WorkTime" placeholder="" clearable filterable size="small" style="width:200px">
                <el-option label="标准工时制" value="0"></el-option>
                <el-option label="不定时工时制" value="1"></el-option>
                <el-option label="综合计算工时制" value="2"></el-option>
              </el-select>
            </el-form-item>

            <el-form-item label="部门" v-if="no==24 || no==27 || no==28 || no==29" prop="list[0].StrDep">
              <el-input v-model="signingForm.list[0].StrDep" style="width:200px" size="small"></el-input>
            </el-form-item>

            <el-form-item label="实习期限时长（月）" v-if="no==29" prop="list[0].StrInterDurMonths">
              <el-input v-model="signingForm.list[0].StrInterDurMonths" style="width:200px" size="small"></el-input>
            </el-form-item>

            <el-form-item label="工作小时" v-if="no== 28" prop="list[0].StrWorkHours">
              <el-input v-model="signingForm.list[0].StrWorkHours" style="width:200px" size="small"></el-input>
            </el-form-item>

            <el-form-item label="工作天数" v-if="no== 28" prop="list[0].StrWorkDays">
              <el-input v-model="signingForm.list[0].StrWorkDays" style="width:200px" size="small"></el-input>
            </el-form-item>

            <el-form-item label="试用期工资" v-if="no == 24 || no == 27 || no==28" prop="list[0].TrialPeriodDec">
              <el-input v-model="signingForm.list[0].TrialPeriodDec" style="width:200px" size="small"></el-input>
            </el-form-item>

            <el-form-item label="户籍地址" v-if="no == 27 || no==28" prop="list[0].StrRegAddress">
              <el-input v-model="signingForm.list[0].StrRegAddress" style="width:200px" size="small"></el-input>
            </el-form-item>
            <el-form-item label="户籍类型" v-if="no == 27" prop="list[0].StrRegType">
              <el-input v-model="signingForm.list[0].StrRegType" style="width:200px" size="small"></el-input>
            </el-form-item>
            <el-form-item label="个人电子邮箱" v-if="no == 27 || no==28 || no==29 || no==32 || no==35|| no==36" :prop="no==27 || no==35 || no==36 ? 'list[0].StrPsnEmail' : ''">
              <el-input v-model="signingForm.list[0].StrPsnEmail" style="width:200px" size="small"></el-input>
            </el-form-item>
            <el-form-item label="个人微信号" v-if="no == 27 || no==28 || no==29" prop="list[0].StrPsnWx">
              <el-input v-model="signingForm.list[0].StrPsnWx" style="width:200px" size="small"></el-input>
            </el-form-item>
            <el-form-item label="个人QQ" v-if="no == 27 || no==28 || no==29">
              <el-input v-model="signingForm.list[0].StrPsnQq" style="width:200px" size="small"></el-input>
            </el-form-item>
            <el-form-item label="紧急联系人" v-if="no == 27 || no == 33 || no==35 || no==36" prop="list[0].StrEmContact">
              <el-input v-model="signingForm.list[0].StrEmContact" style="width:200px" size="small"></el-input>
            </el-form-item>
            <el-form-item label="紧急联系人电话" v-if="no == 27 || no == 33 || no==35 || no==36" prop="list[0].StrEmContactPhone">
              <el-input v-model="signingForm.list[0].StrEmContactPhone" style="width:200px" size="small"></el-input>
            </el-form-item>
            <el-form-item label="紧急联系人邮箱" v-if="no == 27">
              <el-input v-model="signingForm.list[0].StrEmContactEmail" style="width:200px" size="small"></el-input>
            </el-form-item>
            <el-form-item label="紧急联系人地址" v-if="no == 27" prop="list[0].StrEmContactAddr">
              <el-input v-model="signingForm.list[0].StrEmContactAddr" style="width:200px" size="small"></el-input>
            </el-form-item>

            <el-form-item label="合同结束标准" v-if="no == 35">
              <el-input v-model="signingForm.list[0].StrPsnQq" style="width:200px" size="small"></el-input>
            </el-form-item>

            <el-form-item label="验收标志" v-if="no == 35">
              <el-input v-model="signingForm.list[0].StrEmContactAddr" style="width:200px" size="small"></el-input>
            </el-form-item>

            <el-form-item label="备注1" v-if="contractType == 11">
              <el-input v-model="signingForm.list[0].Remark1" style="width:200px" size="small"></el-input>
            </el-form-item>

            <el-form-item label="备注2" v-if="contractType == 11 && no!=25">
              <el-input v-model="signingForm.list[0].Remark2" style="width:200px" size="small"></el-input>
            </el-form-item>

            <el-form-item label="备注3" v-if="contractType == 11 && no!=25">
              <el-input v-model="signingForm.list[0].Remark3" style="width:200px" size="small"></el-input>
            </el-form-item>

            <el-form-item label="暂缓缴纳原因" v-if="no == 25" prop="list[0].StrReasonzh">
              <el-input v-model="signingForm.list[0].StrReasonzh" style="width:200px" size="small"></el-input>
            </el-form-item>

            <el-form-item label="补贴金额" v-if="no && no!=26 && no!=28 && no!=29">
              <el-input v-model="signingForm.list[0].SubsidyAmount" type="number" style="width:200px" size="small"></el-input>
            </el-form-item>

            <el-form-item label="补贴金额大写" v-if="no && no!=26 && no!=28 && no!=29">
              <el-input v-model="signingForm.list[0].SubsidyInstru" style="width:200px" size="small"></el-input>
            </el-form-item>

            <el-form-item label="离职原因" v-if="no==26" prop="list[0].StrReasonLeaving">
              <el-input v-model="signingForm.list[0].StrReasonLeaving" style="width:200px" size="small"></el-input>
            </el-form-item>

            <el-form-item label="保密年限" v-if="no==30">
              <el-input v-model="signingForm.list[0].ConfiPeriod" style="width:200px" size="small"></el-input>
            </el-form-item>

            <el-form-item label="律师费金额" v-if="contractType!=8 && contractType!=9 && contractType!=10 && contractType!=12 && contractType!=13">
              <el-input v-model="signingForm.list[0].LegalFeesAmount" style="width:200px" size="small"></el-input>
            </el-form-item>

            <el-form-item label="律师费金额大写" v-if="contractType!=8 && contractType!=9 && contractType!=10 && contractType!=12 && contractType!=13">
              <el-input v-model="signingForm.list[0].LegalFeesAmountWords" style="width:200px" size="small"></el-input>
            </el-form-item>

          </el-form>

          <div class="tips" v-if="no==30">服务内容:不可直接写岗位，需根据参保岗位，倒推服务内容:(如保安岗位:安保服务保洁岗位:清洁服务;等)如有疑问可与上级主管确认。</div>
          <span slot="footer" class="dialog-footer">
            <el-button @click="showSigning = false" size="small">取 消</el-button>
            <el-button type="primary" v-preventReClick style="margin-left:10px;" @click="confirmSign" size="small">提
              交</el-button>
          </span>
        </el-dialog>

        <el-dialog title="合同预览" :visible.sync="showPreview" width="90%">

          <div v-loading="previewLoading" element-loading-text="加载中···" element-loading-spinner="el-icon-loading" v-if="previewLoading" style="height:500px"></div>
          <div v-if="previewLoading" style="height:500px"></div>
          <iframe style="width: 100%;height:80vh" :src="previewUrl"></iframe>
          <!-- <div class="preview_box">
            <div class="scroll-box">
              <div class="pdf-box">
                <pdf :src="previewUrl" v-for="i in pageTotal" :key="i" :page="i" @num-pages="pageCount=$event" style="width:100%;height:auto" />
              </div>
            </div>
          </div> -->

          <!-- <div class="page">
            <el-button round type="primary" :disabled="currentPage === 1" @click="chengPage">
              上一页
            </el-button>
            <el-button round type="primary" :disabled="currentPage === pageTotal" @click="chengPage('+')">
              下一页
            </el-button>
          </div> -->
        </el-dialog>

        <el-dialog title="修改手机号" :visible.sync="showEditPhone" width="700px">
          <el-form :model="phoneForm" :inline="true" label-width="100px">
            <el-form-item label="姓名">
              <el-input v-model="phoneName" readonly style="width:200px" disabled size="small"></el-input>
            </el-form-item>
            <el-form-item label="手机号">
              <el-input type="number" v-model="phoneForm.Phone" style="width:200px" size="small"></el-input>
            </el-form-item>
            <el-form-item label="文化程度">
              <el-select v-model="phoneForm.StrEduLvl" size="small" style="width: 200px;" placeholder="" filterable>
                <el-option value="博士"></el-option>
                <el-option value="硕士"></el-option>
                <el-option value="本科"></el-option>
                <el-option value="大专"></el-option>
                <el-option value="中专"></el-option>
                <el-option value="高中"></el-option>
                <el-option value="初中及以下"></el-option>
              </el-select>
            </el-form-item>

            <el-form-item label="联系地址">
              <el-input v-model="phoneForm.EmpContactAddress" style="width:400px" size="small"></el-input>
            </el-form-item>
          </el-form>
          <span slot="footer" class="dialog-footer">
            <el-button @click="showEditPhone = false" size="small">取 消</el-button>
            <el-button type="primary" v-preventReClick style="margin-left:10px;" @click="confirmEditPhone" size="small">提
              交</el-button>
          </span>
        </el-dialog>

        <el-dialog title="导出项目签约汇总" :visible.sync="showExportProSum" width="500px">
          <el-form label-width="80px">
            <el-form-item label="月份">
              <el-date-picker v-model="proSumMonth" style="width:200px" type="month" value-format="yyyy-MM"></el-date-picker>
            </el-form-item>
          </el-form>
          <span slot="footer" class="dialog-footer">
            <el-button @click="showExportProSum = false" size="small">取 消</el-button>
            <el-button type="primary" v-preventReClick style="margin-left:10px;" @click="confirmExportProSum" size="small">导
              出</el-button>
          </span>
        </el-dialog>

        <el-dialog title="驳回" :visible.sync="showReject" width="500px">
          <el-form label-width="100px">
            <el-form-item label="驳回原因">
              <el-input v-model="ReturnReasons" style="width:300px" size="small"></el-input>
            </el-form-item>
          </el-form>
          <span slot="footer" class="dialog-footer">
            <el-button @click="showReject = false" size="small">取 消</el-button>
            <el-button type="primary" v-preventReClick style="margin-left:10px;" @click="pass(info, '0')" size="small">提
              交</el-button>
          </span>
        </el-dialog>
      </div>
    </div>
    <el-dialog title="提交电子签约信息" :visible.sync="showEleInfo" width="1100px">
      <el-form :model="eleForm" v-if="actFirstName == 'first'" :inline="true" :rules="importRules" ref="eleForm" label-width="135px">
        <el-form-item label="签约模板" prop="tempid">
          <el-select v-model="TempName" placeholder="" clearable filterable size="small" style="width:200px" value-key="TempId" @change="val => { changeTemp2(val) }">
            <el-option v-for="(item, index) in tempEleList" :key="index" :label="item.TempName" :value="item" size="small"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="合同/协议类型" prop="ProtocolType">
          <el-select v-model="eleForm.ProtocolType" value-key="name" placeholder="" clearable filterable size="small" @change="(val) => { changeCont(val, 'eleForm') }" style="width:200px">
            <el-option v-for="(item, index) in contractList" :key="index" :label="item.name" :value="item"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="员工签约主体" prop="ContractSubject">
          <el-select v-model="eleForm.ContractSubject" placeholder="" clearable filterable style="width:200px" @change="(val) => { changeLeg(val, 'eleForm') }" size="small">
            <el-option v-for="(item, index) in legList" :key="index" :value="item.name"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="法人" prop="LegalPer">
          <el-input v-model="eleForm.LegalPer" readonly style="width:200px" disabled size="small"></el-input>
        </el-form-item>
        <el-form-item label="注册地址" prop="RegisterAddress">
          <el-input v-model="eleForm.RegisterAddress" readonly style="width:200px" disabled size="small"></el-input>
        </el-form-item>
        <el-form-item label="统一社会信用代码" prop="TaxNum" v-if="contractType<8">
          <el-input v-model="eleForm.TaxNum" readonly style="width:200px" disabled size="small"></el-input>
        </el-form-item>
        <el-form-item label="报税地" v-if="contractType<8">
          <el-input v-model="eleForm.TaxCity" style="width:200px" size="small"></el-input>
        </el-form-item>

        <el-form-item label="工作地点（区域）" prop="WorkSite" v-if="(contractType == 5 || contractType == 6) && no!=28 && no!=33">
          <el-input v-model="eleForm.WorkSite" style="width:200px" size="small"></el-input>
        </el-form-item>
        <el-form-item label="学校全称" prop="SchoolName" v-if="(contractType == 3 || contractType == 9) && no!=29 && no!=32 && no!=33">
          <el-input v-model="eleForm.SchoolName" style="width:200px" size="small"></el-input>
        </el-form-item>
        <el-form-item label="学生专业" prop="StudentMajor" v-if="contractType == 9">
          <el-input v-model="eleForm.StudentMajor" style="width:200px" size="small"></el-input>
        </el-form-item>
        <el-form-item label="入职日期" :prop="contractType == 8 || contractType == 9 || contractType == 10 ? '' : 'list[0].DtEntryBdate'" v-if="contractType != 11 && contractType != 12 && no!=24 && no!=26 && no!=27 && no!=28 && no!=29 && no!=32 && no!=33">
          <el-date-picker type="date" placeholder="" v-model="eleForm.list[0].DtEntryBdate" value-format="yyyy-MM-dd" style="width:200px" size="small" @blur="changeTimeLaborContract('eleForm', val)"></el-date-picker>
        </el-form-item>
        <el-form-item label="客户单位全称">
          <el-input v-model="eleForm.list[0].ClientFullName" style="width:200px" size="small"></el-input>
        </el-form-item>
        <el-form-item :label="contractType != 9 || contractType != 10 ? '合同起始时间' : '协议起始时间'" prop="ContractStartTime" v-if="contractType != 9 && contractType != 10 && contractType">
          <el-date-picker type="date" placeholder="" v-model="eleForm.ContractStartTime" value-format="yyyy-MM-dd" style="width:200px" size="small"></el-date-picker>
        </el-form-item>
        <el-form-item v-if="contractType != 9 && contractType != 10 && contractType != 11 && contractType != 12 && contractType != 13 && contractType && no!=26 && no!=33">
          <template #label>
            <span v-if="contractType != 9 || contractType != 10">合同时长<span style="color:red">{{ no==30 || no==33 ? '（月）' : '（年）'}}</span></span>
            <span v-else>协议时长<span style="color:red">{{ no==30 ? '（月）' : '（年）'}}</span></span>
          </template>
          <el-input type="number" v-model="ContractTime" @blur="getContractEndDate(ContractTime,'eleForm')" style="width:200px" size="small" :disabled="!eleForm.ContractStartTime"></el-input>
        </el-form-item>
        <el-form-item v-if="no==33">
          <template #label>
            <span>合同时长（<span style="color:red">月</span>）</span>
          </template>
          <el-input type="number" v-model="eleForm.WorkingMonth" @blur="getContractEndDate(eleForm.WorkingMonth,'eleForm')" style="width:200px" size="small" :disabled="!eleForm.ContractStartTime"></el-input>
        </el-form-item>
        <el-form-item :label="contractType != 9 || contractType != 10 ? '合同结束时间 （可编辑更改）' : '协议结束时间 （可编辑更改）'" prop="ContractEndTime" v-if="contractType != 9 && contractType != 10 && contractType != 13 && no != 22 && contractType">
          <el-date-picker type="date" placeholder="" v-model="eleForm.ContractEndTime" value-format="yyyy-MM-dd" style="width:200px" size="small"></el-date-picker>
        </el-form-item>
        <el-form-item label="合同结束时间" v-if="contractType == 13 || no == 22">
          <el-input v-model="noDateTxt" style="width:200px" size="small" readonly disabled></el-input>
        </el-form-item>
        <el-form-item label="试用期起始时间" prop="TrialPeriodStartTime" v-if="contractType == 1 || contractType == 2 || contractType == 5 || contractType == 7">
          <el-date-picker type="date" placeholder="" v-model="eleForm.TrialPeriodStartTime" value-format="yyyy-MM-dd" style="width:200px" size="small"></el-date-picker>
        </el-form-item>
        <el-form-item label="试用期时长(月)" prop="TrialMonth" v-if="contractType == 1 || contractType == 2 || contractType == 5 || contractType == 7">
          <el-input type="number" v-model="eleForm.TrialMonth" style="width:200px" size="small" :disabled="!eleForm.TrialPeriodStartTime" @blur="getEndDate('eleForm')"></el-input>
        </el-form-item>
        <el-form-item label="试用期结束时间（可编辑更改）" prop="TrialPeriodEndTime" v-if="contractType == 1 || contractType == 2 || contractType == 5 || contractType == 7">
          <el-date-picker type="date" placeholder="" v-model="eleForm.TrialPeriodEndTime" value-format="yyyy-MM-dd" style="width:200px" size="small"></el-date-picker>
        </el-form-item>
        <el-form-item :label="contractType == 8 ? '终止（解除）劳动合同时间' : '终止（解除）协议时间'" prop="TimeLaborContract" v-if="contractType == 8 || contractType == 9 || contractType == 10">
          <el-date-picker type="date" placeholder="" v-model="eleForm.TimeLaborContract" value-format="yyyy-MM-dd" style="width:200px" size="small" @change="val => { changeTimeLaborContract('eleForm', val) }"></el-date-picker>
        </el-form-item>
        <el-form-item label="工作时长(年)" prop="WorkingYear" v-if="contractType == 8">
          <el-input v-model="eleForm.WorkingYear" style="width:200px" size="small"></el-input>
        </el-form-item>
        <el-form-item label="工作时长(月)" prop="WorkingMonth" v-if="contractType == 8">
          <el-input v-model="eleForm.WorkingMonth" style="width:200px" size="small"></el-input>
        </el-form-item>
        <el-form-item label="工作时长(天)" prop="WorkingDay" v-if="contractType == 8">
          <el-input v-model="eleForm.WorkingDay" style="width:200px" size="small"></el-input>
        </el-form-item>
        <el-form-item :label="contractType == 8 ? '终止（解除）劳动合同时间（员工联）' : '终止（解除）协议时间（员工联）'" prop="TimeLaborContractStaff" v-if="contractType == 8 || contractType == 9 || contractType == 10">
          <el-date-picker type="date" placeholder="" v-model="eleForm.TimeLaborContractStaff" value-format="yyyy-MM-dd" style="width:200px" size="small"></el-date-picker>
        </el-form-item>
        <el-form-item :label="no!=30 ? '发薪日' : '发放日'" v-if="contractType != 8 && contractType != 9 && contractType != 10 && contractType != 12 && contractType != 13 && no!=25 && no!=24 && no!=26 && no!=27 && no!=28 && no!=29 && no!=31">
          <el-input v-model="eleForm.PayDay" style="width:200px" size="small"></el-input>
        </el-form-item>
        <el-form-item label="工资标准方式" v-if="contractType != 8 && contractType != 9 && contractType != 10 && contractType != 12 && contractType != 13 && no!=25 && no!=26 && no!=28 && no!=29 && no!=30 && no!=31">
          <el-select v-model="eleForm.MeansOfPayments" placeholder="" clearable filterable size="small" style="width:200px">
            <el-option value="0" label="固定工资"></el-option>
            <el-option value="1" label="基本工资+绩效工资"></el-option>
            <el-option value="2" label="计件工资"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="工资" v-if="contractType != 8 && contractType != 9 && contractType != 10 && contractType != 12 && contractType != 13 && no!=25 && no!=26 && no!=30 && no!=31 && no!=33 && no!=33" :prop="no==24 || no==27 || no==28 || no==29 ? 'Yuan' : ''">
          <el-input v-model="eleForm.Yuan" type="number" style="width:200px" size="small"></el-input>
        </el-form-item>

        <el-form-item label="月岗位工资" v-if="no == 33" prop="list[0].StrInterDurMonths">
          <el-input v-model="eleForm.list[0].StrInterDurMonths" style="width:200px" size="small"></el-input>
        </el-form-item>

        <el-form-item label="月绩效工资" v-if="no == 33" prop="list[0].StrReasonLeaving">
          <el-input v-model="eleForm.list[0].StrReasonLeaving" style="width:200px" size="small"></el-input>
        </el-form-item>

        <el-form-item label="税前基本工资" v-if="no==32">
          <el-input v-model="eleForm.list[0].StrWorkHours" style="width:200px" size="small"></el-input>
        </el-form-item>

        <el-form-item label="税前月岗位津贴" v-if="no==32">
          <el-input v-model="eleForm.list[0].StrInterDurMonths" style="width:200px" size="small"></el-input>
        </el-form-item>
        <el-form-item label="城市" v-if="no == 23 || no == 2">
          <el-input v-model="eleForm.WorkCity" style="width:200px" size="small"></el-input>
        </el-form-item>

        <el-form-item label="工时" v-if="no == 23 || no == 24 || no == 27" :prop="no=='24' || no==27 ? 'WorkTime' : ''">
          <el-select v-model="eleForm.WorkTime" placeholder="" clearable filterable size="small" style="width:200px">
            <el-option label="标准工时制" value="0"></el-option>
            <el-option label="不定时工时制" value="1"></el-option>
            <el-option label="综合计算工时制" value="2"></el-option>
          </el-select>
        </el-form-item>
        <el-table :data="eleForm.list" class="doc_table" border max-height="300px" style="width:100%;margin-top: 10px;">
          <el-table-column label="序号" width="50">
            <template slot-scope="scope">
              {{ scope.$index + 1 }}
            </template>
          </el-table-column>
          <el-table-column prop="name" label="姓名" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="PhoneNum" label="电话" :show-overflow-tooltip="true" align="center" min-width="95">
          </el-table-column>
          <el-table-column prop="StrIdCard" label="身份证号码" :show-overflow-tooltip="true" align="center" min-width="156">
          </el-table-column>
          <el-table-column prop="StrObjName" label="项目名称" :show-overflow-tooltip="true" align="center" min-width="140">
          </el-table-column>
          <el-table-column prop="Gender" label="性别" v-if="no==32" align="center" min-width="120">
            <template slot-scope="{row}">
              <el-select v-model="row.Gender" placeholder="" clearable filterable style="width:100px" size="small">
                <el-option value="男"></el-option>
                <el-option value="女"></el-option>
              </el-select>
            </template>
          </el-table-column>
          <el-table-column prop="JobName" label="合同岗位" align="center" min-width="140px">
            <template slot-scope="{row}">
              <el-input v-model="row.JobName" size="small" style="width:130px"></el-input>
            </template>
          </el-table-column>
          <el-table-column prop="StrEduLvl" label="文化程度" :show-overflow-tooltip="true" align="center" min-width="130" v-if="contractType && contractType < 8  && no!=24 && no!=28 && no!=29 && no!=32 && no!=33">
            <template slot-scope="{row}">
              <el-select v-model="row.StrEduLvl" size="small" style="width: 110px;" placeholder="" filterable>
                <el-option value="博士"></el-option>
                <el-option value="硕士"></el-option>
                <el-option value="本科"></el-option>
                <el-option value="大专"></el-option>
                <el-option value="中专"></el-option>
                <el-option value="高中"></el-option>
                <el-option value="初中及以下"></el-option>
              </el-select>
            </template>
          </el-table-column>
          <el-table-column prop="ClientFullName" label="客户单位全称" align="center" min-width="140px">
            <template slot-scope="{row}">
              <el-input v-model="row.ClientFullName" size="small" style="width:130px"></el-input>
            </template>
          </el-table-column>
          <el-table-column prop="Bankcard" label="银行卡号" align="center" min-width="130" v-if="contractType != 11 && contractType != 12 && contractType != 13 && no!=24 && no!=26 && no!=32 && no!=33">
            <template slot-scope="{row}">
              <el-input v-model="row.Bankcard" size="small" style="width:120px"></el-input>
            </template>
          </el-table-column>
          <el-table-column prop="DepositBank" label="开户银行" align="center" min-width="130" v-if="contractType != 11 && contractType != 12 && contractType != 13 && no!=24 && no!=26 && no!=32 && no!=33">
            <template slot-scope="{row}">
              <el-input v-model="row.DepositBank" size="small" style="width:120px"></el-input>
            </template>
          </el-table-column>
          <el-table-column prop="EmpContactAddress" label="户籍地址" align="center" min-width="200">
            <template slot-scope="{row}">
              <el-input v-model="row.EmpContactAddress" size="small" style="width:190px"></el-input>
            </template>
          </el-table-column>
          <el-table-column label="部门" align="center" min-width="200" v-if="no == 24">
            <template slot-scope="{row}">
              <el-input v-model="row.StrDep" size="small" style="width:140px"></el-input>
            </template>
          </el-table-column>
          <el-table-column label="试用期工资" align="center" min-width="200" v-if="no == 24">
            <template slot-scope="{row}">
              <el-input v-model="row.TrialPeriodDec" size="small" type="number" style="width:140px"></el-input>
            </template>
          </el-table-column>
          <el-table-column label="暂缓缴纳原因" align="center" min-width="200" v-if="no == 25">
            <template slot-scope="{row}">
              <el-input v-model="row.StrReasonzh" size="small" style="width:140px"></el-input>
            </template>
          </el-table-column>
          <el-table-column label="补贴金额" align="center" min-width="200" v-if="no && no!=26 && no!=28 && no!=29">
            <template slot-scope="{row}">
              <el-input v-model="row.SubsidyAmount" size="small" type="number" style="width:140px"></el-input>
            </template>
          </el-table-column>
          <el-table-column label="补贴金额大写" align="center" min-width="200" v-if="no && no!=26 && no!=28 && no!=29">
            <template slot-scope="{row}">
              <el-input v-model="row.SubsidyInstru" size="small" style="width:140px"></el-input>
            </template>
          </el-table-column>
          <el-table-column label="保密年限" align="center" min-width="200" v-if="no==30">
            <template slot-scope="{row}">
              <el-input v-model="row.ConfiPeriod" size="small" style="width:140px"></el-input>
            </template>
          </el-table-column>

          <el-table-column label="个人电子邮箱" align="center" min-width="200" v-if="no == 27 || no==28 || no==29 || no==32">
            <template slot-scope="{row}">
              <el-input v-model="row.StrPsnEmail" size="small" style="width:140px"></el-input>
            </template>
          </el-table-column>
          <el-table-column label="个人微信号" align="center" min-width="200" v-if="no == 27 || no==28 || no==29">
            <template slot-scope="{row}">
              <el-input v-model="row.StrPsnWx" size="small" style="width:140px"></el-input>
            </template>
          </el-table-column>
          <el-table-column label="个人QQ" align="center" min-width="200" v-if="no == 27 || no==28 || no==29">
            <template slot-scope="{row}">
              <el-input v-model="row.StrPsnQq" size="small" style="width:140px"></el-input>
            </template>
          </el-table-column>
          <el-table-column label="紧急联系人" align="center" min-width="200" v-if="no == 27 || no == 33">
            <template slot-scope="{row}">
              <el-input v-model="row.StrEmContact" size="small" style="width:140px"></el-input>
            </template>
          </el-table-column>
          <el-table-column label="紧急联系人电话" align="center" min-width="200" v-if="no == 27 || no == 33">
            <template slot-scope="{row}">
              <el-input v-model="row.StrEmContactPhone" size="small" style="width:140px"></el-input>
            </template>
          </el-table-column>
          <el-table-column label="紧急联系人邮箱" align="center" min-width="200" v-if="no == 27">
            <template slot-scope="{row}">
              <el-input v-model="row.StrEmContactEmail" size="small" style="width:140px"></el-input>
            </template>
          </el-table-column>
          <el-table-column label="紧急联系人地址" align="center" min-width="200" v-if="no == 27">
            <template slot-scope="{row}">
              <el-input v-model="row.StrEmContactAddr" size="small" style="width:140px"></el-input>
            </template>
          </el-table-column>

          <el-table-column label="律师费金额" align="center" min-width="200" v-if="contractType!=8 && contractType!=9 && contractType!=10 && contractType!=12 && contractType!=13">
            <template slot-scope="{row}">
              <el-input v-model="row.LegalFeesAmount" size="small" style="width:140px"></el-input>
            </template>
          </el-table-column>

          <el-table-column label="律师费金额大写" align="center" min-width="200" v-if="contractType!=8 && contractType!=9 && contractType!=10 && contractType!=12 && contractType!=13">
            <template slot-scope="{row}">
              <el-input v-model="row.LegalFeesAmountWords" size="small" style="width:140px"></el-input>
            </template>
          </el-table-column>
        </el-table>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="showEleInfo = false" size="small">取消</el-button>
        <el-button type="primary" v-preventReClick size="small" @click="confirmToEle">去电子签约</el-button>
      </span>
    </el-dialog>

    <el-dialog title="线下签约登记" :visible.sync="showOfflineSigning" width="800px">
      <el-form :model="offRegForm" :rules="offRegRules" ref="offRegForm" :inline="true" label-width="125px">
        <el-form-item label="身份证姓名" prop="Name">
          <el-input v-model="offRegForm.Name" style="width:200px"></el-input>
        </el-form-item>
        <el-form-item label="身份证号码" prop="StrIdCard">
          <el-input v-model="offRegForm.StrIdCard" style="width:200px"></el-input>
        </el-form-item>
        <el-form-item label="项目名称" prop="StrObjName">
          <el-select v-model="offRegForm.StrObjName" placeholder="" clearable filterable style="width:200px">
            <el-option v-for="item in proList" :key="item.Id" :label="item.StrprojectName" :value="item.StrprojectName"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="员工签约主体" prop="ContractSubject">
          <el-select v-model="offRegForm.ContractSubject" placeholder="" clearable filterable style="width:200px">
            <el-option v-for="(item, index) in legList" :key="index" :value="item.name"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="签约类型" prop="ProtocolType">
          <el-select v-model="offRegForm.ProtocolType" placeholder="" clearable filterable style="width:200px">
            <el-option v-for="(item, index) in contractList" :key="index" :label="item.name" :value="item.name"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="入职日期" prop="dtEntryBDate">
          <el-date-picker type="date" placeholder="" v-model="offRegForm.dtEntryBDate" value-format="yyyy-MM-dd" style="width:200px"></el-date-picker>
        </el-form-item>
        <el-form-item label="合同签约时间" prop="SignatureTime">
          <el-date-picker type="date" placeholder="" v-model="offRegForm.SignatureTime" value-format="yyyy-MM-dd" style="width:200px"></el-date-picker>
        </el-form-item>
        <el-form-item label="合同起始时间" prop="ContractStartTime">
          <el-date-picker type="date" placeholder="" v-model="offRegForm.ContractStartTime" value-format="yyyy-MM-dd" style="width:200px"></el-date-picker>
        </el-form-item>
        <el-form-item label="合同结束时间" prop="ContractEndTime">
          <el-date-picker type="date" placeholder="" v-model="offRegForm.ContractEndTime" value-format="yyyy-MM-dd" style="width:200px"></el-date-picker>
        </el-form-item>
        <el-form-item label="附件">
          <div class="upload_box">
            <el-upload class="upload-demo" action="" :on-change="success_handle" :auto-upload="false" :limit="1" :on-remove="handleRemove" :on-exceed="handleExceed" :file-list="fileList">
              <el-button size="small" type="success">上传附件</el-button>
            </el-upload>
          </div>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="showOfflineSigning = false" size="small">取消</el-button>
        <el-button type="primary" v-preventReClick size="small" @click="confirmOfflineSigning" :loading="isBtnLoading">确定</el-button>
      </span>
    </el-dialog>

    <el-dialog title="批量线下签约登记" :visible.sync="showBatchOfflineSigning" width="1050px">
      <el-form :inline="true" label-width="125px">
        <el-form-item label="批量签约主体">
          <el-select v-model="batchOff.ContractSubject" placeholder="" clearable filterable size="small" style="width:200px" @change="batchContractSubject">
            <el-option v-for="(item, index) in legList" :key="index" :value="item.name"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="批量签约类型">
          <el-select v-model="batchOff.ProtocolType" placeholder="" clearable filterable size="small" style="width:200px" @change="batchProtocolType">
            <el-option v-for="(item, index) in contractList" :key="index" :label="item.name" :value="item.name"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="批量入职日期">
          <el-date-picker type="date" placeholder="" v-model="batchOff.dtEntryBDate" value-format="yyyy-MM-dd" size="small" style="width:200px" @change="batchdtEntryBDate"></el-date-picker>
        </el-form-item>
        <el-form-item label="批量合同签约时间">
          <el-date-picker type="date" placeholder="" v-model="batchOff.SignatureTime" value-format="yyyy-MM-dd" size="small" style="width:200px" @change="batchSignatureTime"></el-date-picker>
        </el-form-item>
        <el-form-item label="批量合同起始时间">
          <el-date-picker type="date" placeholder="" v-model="batchOff.ContractStartTime" value-format="yyyy-MM-dd" size="small" style="width:200px" @change="batchContractStartTime"></el-date-picker>
        </el-form-item>
        <el-form-item label="批量合同结束时间">
          <el-date-picker type="date" placeholder="" v-model="batchOff.ContractEndTime" value-format="yyyy-MM-dd" size="small" style="width:200px" @change="batchContractEndTime"></el-date-picker>
        </el-form-item>
      </el-form>
      <el-table :data="offlineList" class="doc_table" border max-height="300px" style="width:100%;margin-top: 10px;">
        <el-table-column label="序号" width="50" align="center">
          <template slot-scope="scope">
            {{ scope.$index + 1 }}
          </template>
        </el-table-column>
        <el-table-column label="身份证姓名" align="center" width="125px">
          <template slot-scope="{row}">
            <el-input v-model="row.Name" size="small" style="width:100px"></el-input>
          </template>
        </el-table-column>
        <el-table-column label="身份证号码" align="center" width="185px">
          <template slot-scope="{row}">
            <el-input v-model="row.StrIdCard" size="small" style="width:160px"></el-input>
          </template>
        </el-table-column>
        <el-table-column label="项目名称" align="center" width="200px">
          <template slot-scope="{row}">
            <el-select v-model="row.StrObjName" placeholder="" clearable filterable size="small" style="width:170px">
              <el-option v-for="item in proList" :key="item.Id" :label="item.StrprojectName" :value="item.StrprojectName"></el-option>
            </el-select>
          </template>
        </el-table-column>
        <el-table-column label="员工签约主体" align="center" width="200px">
          <template slot-scope="{row}">
            <el-select v-model="row.ContractSubject" placeholder="" clearable filterable size="small" style="width:170px">
              <el-option v-for="(item, index) in legList" :key="index" :value="item.name"></el-option>
            </el-select>
          </template>
        </el-table-column>
        <el-table-column label="签约类型" align="center" width="140px">
          <template slot-scope="{row}">
            <el-select v-model="row.ProtocolType" placeholder="" clearable filterable size="small" style="width:120px">
              <el-option v-for="(item, index) in contractList" :key="index" :label="item.name" :value="item.name"></el-option>
            </el-select>
          </template>
        </el-table-column>
        <el-table-column label="入职日期" align="center" width="140px">
          <template slot-scope="{row}">
            <el-date-picker type="date" placeholder="" v-model="row.dtEntryBDate" value-format="yyyy-MM-dd" size="small" style="width:120px"></el-date-picker>
          </template>
        </el-table-column>
        <el-table-column label="合同签约时间" align="center" width="140px">
          <template slot-scope="{row}">
            <el-date-picker type="date" placeholder="" v-model="row.SignatureTime" value-format="yyyy-MM-dd" size="small" style="width:120px"></el-date-picker>
          </template>
        </el-table-column>
        <el-table-column label="合同起始时间" align="center" width="140px">
          <template slot-scope="{row}">
            <el-date-picker type="date" placeholder="" v-model="row.ContractStartTime" value-format="yyyy-MM-dd" size="small" style="width:120px"></el-date-picker>
          </template>
        </el-table-column>
        <el-table-column label="合同结束时间" align="center" width="140px">
          <template slot-scope="{row}">
            <el-date-picker type="date" placeholder="" v-model="row.ContractEndTime" value-format="yyyy-MM-dd" size="small" style="width:120px"></el-date-picker>
          </template>
        </el-table-column>
      </el-table>
      <span slot="footer" class="dialog-footer">
        <el-button @click="showBatchOfflineSigning = false" size="small">取消</el-button>
        <el-button type="primary" v-preventReClick size="small" @click="confirmBatchOfflineSigning" :loading="isBtnLoading">确定</el-button>
      </span>
    </el-dialog>

    <el-dialog title="作废" :visible.sync="showDeleteReason" width="450px">
      <el-form label-width="80px">
        <el-form-item label="作废原因">
          <el-input v-model="delForm.DeleteReason" size="small" style="width:300px"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="showDeleteReason = false" size="small">取消</el-button>
        <el-button type="primary" v-preventReClick size="small" @click="confirmDel" :loading="isBtnLoading">确定</el-button>
      </span>
    </el-dialog>

    <el-dialog title="提示" :visible.sync="showResubmit" width="450px">
      <div>{{ submitMsg }}</div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="cancelSubmit" size="small">取消</el-button>
        <el-button type="danger" v-preventReClick size="small" @click="forceSubmit">强制提交</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
  import xz from "../../common";
  import moment from 'moment';
  import FUN from "../../fun";
  import checkPermission from '@/utils/permission' // 权限判断函数
  import pdf from 'vue-pdf' //引入下载的vue-pdf
  import CMapReaderFactory from "vue-pdf/src/CMapReaderFactory.js";
  import "moment-precise-range-plugin"
  import {
    tan
  } from "mathjs";
  export default {
    components: {
      pdf
    },
    data() {
      var validatetJobTips = (rule, value, callback) => {
        if (!this.signingForm.list[0].JobName) {
          if (this.jobNameLabel == '工作岗位(A管理类、B技术类、C操作类)' || this.jobNameLabel == '工作岗位(A管理、B技术、C操作)') {
            callback(new Error("请输入字母：A或B或C"));
          } else {
            callback(new Error("请输入工作岗位"));
          }

        } else {
          callback();
        }
      };
      return {
        tableHeight: 0,
        showDropScreen: -1, //筛选下拉框 
        totalCount: 0,
        actFirstName: '发起签约',
        activeName: 'first',
        tableData: [],
        loading: false,
        roletype: localStorage.loginRoletype,
        roleName: localStorage.roleName,
        multipleSelection: [], //表格多选列表
        listQuery: {
          SignatureStatus: '发起签约', //状态
          ProjectName: '',
          CardId: '',
          ApproResult: '',
          IsEmpSignTimeAsc: '', //是否按时间升序
          Name: '',
          PhoneNum: '',
          ContractSubject: '', //主体名称
          ObjName: '', //项目名称
          TempType: '', //合同类型
          tempName: '', //合同名称
          ContractId: '', //合同编号
          EmpSigningStartTime: '', //员工签署开始时间
          EmpSigninEndTime: '', //员工签署结束时间
          ApprovalStartTime: '', //盖章开始时间
          ApprovalEndTTime: '', //盖章结束时间
          Remark1: '',
          Remark2: '',
          Remark3: '',
          WorkSite: '', //地区
          pageNum: 1,
          pageSize: 10,
          IsExport: 0, //0查询列表  1导出
        },
        // 禁用日期范围
        pickerOptions: {
          disabledDate(time) {
            return time.getTime() > Date.now()
          }
        },
        setDateRange: {
          disabledDate: this.disabledDate
        },
        initNum: 0, //发起签约数量
        signedNum: 0, //待签字数量
        firstApproveNum: 0, //初审数量
        approveNum: 0, //待审批数量
        passNum: 0, //通过数量
        passNum2: 0, //已签约归档数量
        notPassNum: 0, //不通过数量
        refuseNum: 0, //拒签数量
        overdueNum: 0, //逾期未签署数量
        delNum: 0,
        offineNum: 0,
        showSendMessage: false, //发送短信弹窗
        messageIds: '',
        showImport: false, //导入签约表弹窗
        legList: [], //主体列表
        importForm: {
          url: '',
          ObjName: '', //项目名称
          ContractSubject: '', //主体
          tempid: '',
          ContractSubject: '', //签约主体
          LegalPer: '', //法人
          RegisterAddress: '', //注册地址
          TaxNum: '', //统一社会信用代码
          TaxCity: '',
          ProtocolType: '', //合同/协议类型
          MeansOfPayments: '', //工资标准方式
          ClientFullName: '', //客户单位全称
          PayDay: '',
          Yuan: '',
          // WorkCity: '',
          // WorkTime: '',
        },
        showResubmit: false,
        submitMsg: '', //重复提交提示
        importRules: {
          ObjName: {
            required: true,
            message: '请选择项目',
            trigger: 'change'
          },
          tempid: {
            required: true,
            message: '请选择签约模板',
            trigger: 'change'
          },
          ContractSubject: {
            required: true,
            message: '请选择主体',
            trigger: 'change'
          },
          LegalPer: {
            required: true,
            message: '请选择法人',
            trigger: 'change'
          },
          RegisterAddress: {
            required: true,
            message: '请选择注册地址',
            trigger: 'change'
          },
          TaxNum: {
            required: true,
            message: '请输入统一社会信用代码',
            trigger: 'blur'
          },
          ProtocolType: {
            required: true,
            message: '请选择合同/协议类型',
            trigger: 'change'
          },
          'list[0].DtEntryBdate': {
            required: true,
            message: '请选择入职日期',
            trigger: 'change'
          },
          ContractStartTime: {
            required: true,
            message: '请选择合同起始时间',
            trigger: 'change'
          },
          ContractEndTime: {
            required: true,
            message: '请选择合同结束时间',
            trigger: 'change'
          },
          TrialPeriodStartTime: {
            required: true,
            message: '请选择试用期起始时间',
            trigger: 'change'
          },
          TrialPeriodEndTime: {
            required: true,
            message: '请选择试用期结束时间',
            trigger: 'change'
          },
          TrialMonth: {
            required: true,
            message: '请选择合同起始时间',
            trigger: 'blur'
          },
          'list[0].name': {
            required: true,
            message: '请输入姓名',
            trigger: 'blur'
          },
          'list[0].PhoneNum': {
            required: true,
            message: '请输入电话',
            trigger: 'blur'
          },
          'list[0].StrIdCard': {
            required: true,
            message: '请输入身份证',
            trigger: 'blur'
          },
          'list[0].JobName': {
            required: true,
            validator: validatetJobTips,
            trigger: 'blur'
          },
          SchoolName: {
            required: true,
            message: '学校全称',
            trigger: 'blur'
          },
          WorkSite: {
            required: true,
            message: '请输入工作地点(区域)',
            trigger: 'blur'
          },
          PayDay: {
            required: true,
            message: '请输入发薪日',
            trigger: 'blur'
          },
          MeansOfPayments: {
            required: true,
            message: '请选择工资标准方式',
            trigger: 'blur'
          },
          Yuan: {
            required: true,
            message: '请输入工资',
            trigger: 'blur'
          },
          StrReasonzh: {
            required: true,
            message: '请输入暂缓缴纳原因',
            trigger: 'blur'
          },
          WorkTime: {
            required: true,
            message: '请输入工时',
            trigger: 'blur'
          },
          WorkingYear: {
            required: true,
            message: '请输入工作时长(年)',
            trigger: 'blur'
          },
          WorkingMonth: {
            required: true,
            message: '请输入工作时长(月)',
            trigger: 'blur'
          },
          WorkingDay: {
            required: true,
            message: '请输入工作时长(天)',
            trigger: 'blur'
          },
          TimeLaborContract: {
            required: true,
            message: '请选择终止（解除）劳动合同/协议时间',
            trigger: 'change'
          },
          TimeLaborContractStaff: {
            required: true,
            message: '请选择终止（解除）劳动合同/协议时间（员工联）',
            trigger: 'change'
          },
          StudentMajor: {
            required: true,
            message: '请输入学生专业',
            trigger: 'blur'
          },
          'list[0].StrEduLvl': {
            required: true,
            message: '请输入文化程度',
            trigger: 'blur'
          },
          'list[0].EmpContactAddress': {
            required: true,
            message: '请输入联系地址',
            trigger: 'blur'
          },
          'list[0].TrialPeriodDec': {
            required: true,
            message: '请输入试用期工资',
            trigger: 'blur'
          },
          'list[0].StrDep': {
            required: true,
            message: '请输入部门',
            trigger: 'blur'
          },
          'list[0].StrReasonLeaving': {
            required: true,
            message: '请输入离职原因',
            trigger: 'blur'
          },
          'list[0].Bankcard': {
            required: true,
            message: '请输入银行卡号',
            trigger: 'blur'
          },
          'list[0].DepositBank': {
            required: true,
            message: '请输入开户银行',
            trigger: 'blur'
          },
          'list[0].StrRegAddress': {
            required: true,
            message: '请输入户籍地址',
            trigger: 'blur'
          },
          'list[0].StrRegType': {
            required: true,
            message: '请输入',
            trigger: 'blur'
          },
          'list[0].StrRegType': {
            required: true,
            message: '请输入户籍类型',
            trigger: 'blur'
          },
          'list[0].StrPsnWx': {
            required: true,
            message: '请输入个人微信号',
            trigger: 'blur'
          },
          'list[0].StrEmContact': {
            required: true,
            message: '请输入紧急联系人',
            trigger: 'blur'
          },
          'list[0].StrEmContactPhone': {
            required: true,
            message: '请输入紧急联系人电话',
            trigger: 'blur'
          },
          'list[0].StrEmContactAddr': {
            required: true,
            message: '请输入紧急联系人地址',
            trigger: 'blur'
          },
          'list[0].StrWorkHours': {
            required: true,
            message: '请输入工作小时',
            trigger: 'blur'
          },
          'list[0].StrWorkDays': {
            required: true,
            message: '请输入工作天数',
            trigger: 'blur'
          },
          'list[0].StrInterDurMonths': {
            required: true,
            message: '请输入',
            trigger: 'blur'
          },
        },
        isUploadSuccess: false, //是否上传成功
        ExcelSrc: {
          value: "",
          check: false,
          fileName: "",
        },
        tempEleList: [],
        headPath: this.$store.state.EMP.docPath,
        showSigning: false, //单笔签约 弹窗
        signingForm: {
          tempid: '',
          ObjName: '', //项目名称
          ContractSubject: '', //签约主体
          LegalPer: '', //法人
          RegisterAddress: '', //注册地址
          TaxNum: '',
          TaxCity: '',
          ContractStartTime: '', //合同起始时间
          ContractEndTime: '', //合同结束时间
          TrialPeriodStartTime: '', //试用期起始时间
          TrialPeriodEndTime: '', //试用期结束时间
          TrialMonth: '', //试期月份
          WorkSite: '', //工作地点
          SchoolName: '', //学校
          WorkingYear: '', //工作时长(年)
          WorkingMonth: '', //工作时长(月)
          WorkingDay: '', //工作时长(天)
          TimeLaborContract: '', //终止（解除）劳动合同时间
          TimeLaborContractStaff: '', //终止（解除）劳动合同时间（员工联）
          MeansOfPayments: '', //工资标准方式
          PayDay: '',
          Yuan: '',
          WorkCity: '',
          WorkTime: '',
          list: [{
            name: '',
            PhoneNum: '',
            StrIdCard: '',
            DtEntryBdate: '', //入职日期
            JobName: '', //岗位
            StrEduLvl: '', //文化程度
            ClientFullName: '',
            EmpContactAddress: '', //联系地址
            Bankcard: '', //银行卡号
            DepositBank: '', //开户银行
            Remark1: '',
            Remark2: '',
            Remark3: '',
            StrDep: '', //部门
            TrialPeriodDec: '', ///试用期工资 金额
            StrReasonzh: '', //暂缓缴纳原因
            SubsidyAmount: '', //补贴金额
            SubsidyInstru: '',
            StrRegAddress: '', // 户籍地址
            StrRegType: '', // 户籍类型
            StrPsnQq: '', // 个人QQ
            StrPsnEmail: '', // 个人电子邮箱
            StrPsnWx: '', // 个人微信号
            StrEmContact: '', // 紧急联系人
            StrEmContactPhone: '', // 紧急联系人电话
            StrEmContactEmail: '', // 紧急联系人邮箱
            StrEmContactAddr: '', // 紧急联系人地址
            StrWorkHours: '', // 工作小时
            StrWorkDays: '', // 工作天数
            StrInterDurMonths: '', // 实习期限时长（月）
            StrReasonLeaving: '', // 离职原因
            LegalFeesAmount: '',
            LegalFeesAmountWords: '',
            ConfiPeriod: '', //保密年限
          }]
        },
        proList: [], //项目列表
        tempList: [], //模板列表
        info: {},
        showInspect: false, //审批弹窗
        expLoading: false,
        showBatchDel: false, //批量作废
        permissionLists: [],
        impLoading: false,
        ContractTime: '', //合同时长
        contractList: this.$store.state.EMP.contractList, //合同/协议列表
        contractType: '',
        isSending: false,
        previewUrl: '', //合同预览base64编码
        showPreview: false, //合同预览弹窗
        pageTotal: 0, // pdf总页数
        currentPage: 1, // pdf当前页
        previewLoading: false,
        visibleSendAll: false,
        showEditPhone: false, //修改手机号弹窗
        phoneName: '', //修改手机号姓名
        phoneForm: {
          id: '',
          Phone: '',
          StrEduLvl: '',
          EmpContactAddress: '',
        },
        noDateTxt: '无固定期限',
        showReject: false, //驳回弹窗
        ReturnReasons: '', //驳回原因
        shangTempId: '', //预览合同ID
        tempName: '', //模板名称  批量
        tempNameSingle: '', //模板名称  单笔签约
        showExportProSum: false, //导出项目签约汇总弹窗
        proSumMonth: '',
        interval: null,
        progress: '',
        progresId: '',
        tableHeight: 0,
        jobNameLabel: '工作岗位',
        // 在职未签约
        // 表头参数
        titleQuery: {
          ststus: '在职'
        },
        underQuery: {
          userid: Cookies.get("userid-b"),
          type: 1, //查询类型1：在职2：离职0：全量
          strEmpName: '',
          strIdCard: '',
          strPhoneNum: '',
          dtInsertDate: '',
          projectid: 0, //项目0:全部
          strOther: '-1', //临时工-1：全部1：是0：否
          ageStart: '-1', //年龄始-1:全部
          ageEnd: '-1', //年龄止-1：全部
          expiration: '0', //到期提醒 0:全部 1:身份证到期 2:试用期到期 3:合同到期 4:16周岁以下 5:16~18周岁 6:退休男 7:退休女 8:65周岁以上 9:工伤纠纷
          strEduLv: [],
          dtEntryBdateStart: '', //用工之日始
          dtEntryBdateEnd: '', //用工之日止
          strContractType: [], //合同（协议）类型
          pushName: [],
          pushRemark: '',
          isEnrollment: '-1', //是否参保-1：全部1：是0：否
          isSigning: '0', //是否签约 -1：全部 1：是 0：否 2:将到期
          dtDepartureDateStart: '',
          dtDepartureDateEnd: '',
          pagination: {
            page: 1,
            pageSize: 10,
            orders: []
          }
        },
        no: '',
        tableTitle: [],
        notUnderData: [],
        underMultipleList: [],
        tableLoading: false,
        underTotal: 0,
        multipleEleSelection: [],
        eleForm: { //电子签约信息表单
          tempid: '', //模板id
          ObjName: '',
          ContractSubject: '', //员工签约主体
          LegalPer: '', //法人
          RegisterAddress: '', //注册地址
          TaxNum: '',
          TaxCity: '',
          ContractStartTime: '', //合同开始时间
          ContractEndTime: '', //合同结束时间
          TrialPeriodStartTime: '', //试用期开始时间
          TrialPeriodEndTime: '', //试用期结束时间
          TrialMonth: '', //试用期时长
          ProtocolType: '', //合同/协议类型
          JobName: '', //岗位
          WorkSite: '', //工作地点
          SchoolName: '', //学校
          Bankcard: '', //银行卡号
          DepositBank: '', //开户银行
          WorkingYear: '', //工作时长(年)
          WorkingMonth: '', //工作时长(月)
          WorkingDay: '', //工作时长(天)
          TimeLaborContract: '', //终止（解除）劳动合同时间
          TimeLaborContractStaff: '', //终止（解除）劳动合同时间（员工联）
          StrEduLvl: '', //文化程度
          EmpContactAddress: '', //联系地址
          list: [{
            name: '',
            PhoneNum: '',
            StrIdCard: '',
            DtEntryBdate: '', //入职日期
            JobName: '', //岗位
            StrEduLvl: '', //文化程度
            ClientFullName: '',
            EmpContactAddress: '', //联系地址
            Bankcard: '', //银行卡号
            DepositBank: '', //开户银行
            Remark1: '',
            Remark2: '',
            Remark3: '',
            StrDep: '', //部门
            TrialPeriodDec: '', ///试用期工资 金额
            StrReasonzh: '', //暂缓缴纳原因
            SubsidyAmount: '', //补贴金额
            SubsidyInstru: '',
            StrRegAddress: '', // 户籍地址
            StrRegType: '', // 户籍类型
            StrPsnQq: '', // 个人QQ
            StrPsnEmail: '', // 个人电子邮箱
            StrPsnWx: '', // 个人微信号
            StrEmContact: '', // 紧急联系人
            StrEmContactPhone: '', // 紧急联系人电话
            StrEmContactEmail: '', // 紧急联系人邮箱
            StrEmContactAddr: '', // 紧急联系人地址
            StrWorkHours: '', // 工作小时
            StrWorkDays: '', // 工作天数
            StrInterDurMonths: '', // 实习期限时长（月）
            StrReasonLeaving: '', // 离职原因
            LegalFeesAmount: '',
            LegalFeesAmountWords: '',
            ConfiPeriod: ''
          }], //选中的在职人员列表
        },
        showEleInfo: false, //提交电子签约信息弹窗
        tempType: '', //模板类型
        TempName: '',
        StrCustName: '', //客户合同主体
        isBtnLoading: false,
        isBtnAllLoading: false,
        delForm: {
          id: '',
          DeleteReason: '', //作废原因
        },
        DeleteReason: '',
        showDeleteReason: false,
        offRegForm: { //线下签约登记表单
          Id: '',
          Name: '',
          PhoneNum: '',
          StrObjName: '', //项目名称
          StrIdCard: '', //身份证
          TempType: '用工协议', //签约类型
          ProtocolType: '',
          StrObjName: '', //项目名称
          ContractSubject: '', //员工签约主体
          SignatureTime: '', //合同签约时间
          ContractStartTime: '', //合同开始时间
          ContractEndTime: '', //合同结束时间
          dtEntryBDate: '', //入职日期
          AttachUrl: '', //合同附件
        },
        fileList: [],
        showOfflineSigning: false,
        offRegRules: {
          Name: {
            required: true,
            message: '请输入姓名',
            trigger: 'change'
          },
          StrIdCard: {
            required: true,
            message: '请输入身份证号码',
            trigger: 'change'
          },
          StrObjName: {
            required: true,
            message: '请选择项目',
            trigger: 'change'
          },
          dtEntryBDate: {
            required: true,
            message: '请选择入职日期',
            trigger: 'change'
          },
          ContractSubject: {
            required: true,
            message: '请选择员工签约主体',
            trigger: 'change'
          },
          ProtocolType: {
            required: true,
            message: '请选择员工签约类型',
            trigger: 'change'
          },
          SignatureTime: {
            required: true,
            message: '请选择合同签约时间',
            trigger: 'change'
          },
          ContractStartTime: {
            required: true,
            message: '请选择合同起始时间',
            trigger: 'change'
          },
          ContractEndTime: {
            required: true,
            message: '请选择合同结束时间',
            trigger: 'change'
          },
        },
        eleRules: {
          tempid: {
            required: true,
            message: '请选择模板',
            trigger: 'change'
          },
          ContractSubject: {
            required: true,
            message: '请选择员工签约主体',
            trigger: 'change'
          },
          LegalPer: {
            required: true,
            message: '请选择法人',
            trigger: 'change'
          },
          RegisterAddress: {
            required: true,
            message: '请选择注册地址',
            trigger: 'change'
          },
          TaxNum: {
            required: true,
            message: '请输入请输入统一社会信用代码',
            trigger: 'change'
          },
          ContractStartTime: {
            required: true,
            message: '请选择合同起始时间',
            trigger: 'change'
          },
          ContractEndTime: {
            required: true,
            message: '请选择合同结束时间',
            trigger: 'change'
          },
          TrialPeriodStartTime: {
            required: true,
            message: '请选择试用期起始时间',
            trigger: 'change'
          },
          TrialPeriodEndTime: {
            required: true,
            message: '请选择试用期结束时间',
            trigger: 'change'
          },
          TrialMonth: {
            required: true,
            message: '请输入试用期时长',
            trigger: 'blur'
          },
          ProtocolType: {
            required: true,
            message: '请选择合同/协议类型',
            trigger: 'change'
          },
          JobName: {
            required: true,
            message: '请输入工作岗位（工种）',
            trigger: 'blur'
          },
          SchoolName: {
            required: true,
            message: '学校全称',
            trigger: 'blur'
          },
          WorkSite: {
            required: true,
            message: '请输入工作地点（区域）',
            trigger: 'blur'
          },
          WorkingYear: {
            required: true,
            message: '请输入工作时长(年)',
            trigger: 'blur'
          },
          WorkingMonth: {
            required: true,
            message: '请输入工作时长(月)',
            trigger: 'blur'
          },
          WorkingDay: {
            required: true,
            message: '请输入工作时长(天)',
            trigger: 'blur'
          },
          TimeLaborContract: {
            required: true,
            message: '请选择终止（解除）劳动合同/协议时间',
            trigger: 'change'
          },
          TimeLaborContractStaff: {
            required: true,
            message: '请选择终止（解除）劳动合同/协议时间（员工联）',
            trigger: 'change'
          },
          StudentMajor: {
            required: true,
            message: '请输入学生专业',
            trigger: 'blur'
          }
        },
        offlineList: [],
        showBatchOfflineSigning: false,
        batchOff: {
          ContractSubject: '',
          ProtocolType: '',
          dtEntryBDate: '',
          SignatureTime: '',
          ContractStartTime: '',
          ContractEndTime: '',
        }
      };
    },
    created() {
      this.calHeight();
      if (this.$route.query.actFirstName) {
        this.actFirstName = this.$route.query.actFirstName
        this.listQuery.SignatureStatus = this.$route.query.actFirstName
        this.underQuery.pagination.page = 1;
        this.getList()
      } else {
        if (this.roleName == '客户在线') {
          this.listQuery.SignatureStatus = '通过';
          this.getContractApproList();
        } else {
          this.getContractApproList();
        }
      }
      this.tableTitle = this.$store.state.EMP.tableTitle.filter(item =>
        !['strWorkState', 'dtDepartureDate', 'dtRealDepartureDate'].includes(item.StrColumId)
      );
      this.getLegalSubjectList();
      this.getSearchJobProList();
      this.getButtonPower();
      // this.getTableTitleLists()
    },
    methods: {
      checkPermission,
      // 获取按钮权限
      getButtonPower() {
        let that = this
        let butQuery = {
          path: '/eleSigning',
          powerEnName: 'employee'
        }
        xz.getbtnPowerIdBypage(butQuery).then(res => {
          if (res.status == 'ok') {
            let resmsg = res.msg
            if (!this.isNull(resmsg)) {
              for (let index = 0; index < resmsg.length; index++) {
                let element = resmsg[index];
                that.permissionLists.push(element.Enname);
              }
              // console.log(that.permissionLists)
            } else {
              this.permissionLists = []
            }
          } else {
            this.$message.error('获取按钮权限出错')
            this.permissionLists = []
          }
        })
      },
      //去电子签约
      confirmToEle() {
        this.$refs["eleForm"].validate((valid) => {
          if (valid) {
            xz.submitESigningInfo(this.eleForm, localStorage.loginRoletype).then(res => {
              if (res.status == 'ok') {
                this.$message.success('保存成功！')
                this.getList()
                this.showEleInfo = false;
                this.multipleEleSelection = []
              } else if (res.status == 'Resubmit') {
                this.submitMsg = res.msg
                this.showResubmit = true;
              } else {
                this.$message.error(res.msg)
              }
            })
          }
        })
      },
      cancelSubmit() {
        this.showResubmit = false;
        this.showEleInfo = false;
        this.showSigning = false;
        this.showImport = false;
      },
      forceSubmit() {
        if (this.showEleInfo) {
          let d = JSON.parse(JSON.stringify(this.eleForm));
          d.Resubmit = '1';
          xz.submitESigningInfo(d, localStorage.loginRoletype).then(res => {
            if (res.status == 'ok') {
              this.$message.success('保存成功！')
              this.getList()
              this.showEleInfo = false;
              this.showResubmit = false;
              this.multipleEleSelection = []
            } else {
              this.$message.error(res.msg)
            }
          })
        } else if (this.showSigning) {
          let d = JSON.parse(JSON.stringify(this.signingForm));
          d.Resubmit = '1';
          xz.submitESigningInfo(d, localStorage.loginRoletype).then(res => {
            if (res.status == 'ok') {
              this.$message.success('保存成功！')
              this.getList()
              this.showSigning = false;
              this.showResubmit = false;
              this.multipleEleSelection = []
            } else {
              this.$message.error(res.msg)
            }
          })
        } else {
          let d = JSON.parse(JSON.stringify(this.importForm));
          d.Resubmit = '1';
          xz.batchImportQuery(d, this.roletype).then(res => {
            if (res.status == 'ok') {
              this.$message.success('导入成功！');
              this.showResubmit = false;
              this.showImport = false;
              this.getContractApproList();
            } else {
              this.$message.error(res.msg)
              this.ExcelSrc = {
                value: "",
                check: false,
                fileName: "",
              }
            }
          })
        }
      },
      calHeight() {
        this.tableHeight = Number(document.body.clientHeight);
      },
      isNull(o) {
        // console.log('isnull',o)
        return (
          o == undefined ||
          o == "undefined" ||
          (o + "").indexOf("undefined") > -1 ||
          o == null ||
          o == "" ||
          o == "null" ||
          o == [] ||
          o == "NaN" ||
          o == '[{}]'
        );
      },
      //取签约主体列表
      getLegalSubjectList() {
        let d = {
          userid: Cookies.get("userid-b"),
          companyName: '',
          isCanInsure: false,
          pageNum: 1,
          pageSize: 1000
        }
        xz.ArdCurStat(d, 'GetUserLegalList').then(res => {
          if (res.status == 'ok') {
            this.legList = res.data.date;
          } else {
            this.legList = [];
          }
        })
      },
      //筛选下拉
      dropDownScreen() {
        if (this.showDropScreen == -1) {
          this.showDropScreen = 1;
        } else if (this.showDropScreen == 1) {
          this.showDropScreen = -1;
        }
      },
      searchHandle() {
        this.listQuery.pageNum = 1;
        this.getContractApproList()
      },
      searchHandle1() {
        this.underQuery.pagination.page = 1
        this.getList()
      },
      // 判断在职天数是否是负数
      isMinus(o) {
        return o == undefined || o == "undefined" || (o + '').indexOf("undefined") > -1 || o == null || o == '' || o == 'null' || o == [] || o == 0 || o == 'NaN' || Number(o) < 0
      },
      //初始化电子签约信息表单
      clearEleForm() {
        this.tempType = '';
        this.StrCustName = '';
        this.eleForm = this.$options.data.call(this).eleForm
      },
      //根据项目查已配置好的模板列表
      templatesByProjectList() {
        xz.templatesByProjectList(this.multipleEleSelection[0].strObjName, this.roletype).then(res => {
          if (res.status == 'ok') {
            this.tempEleList = res.data.tempList;
            this.StrCustName = res.data.StrCustName;
          }
        })
      },
      // 在职未签约
      enterSignHandle() {
        if (this.multipleEleSelection.length == 0) {
          this.$message.warning('请至少选择一位人员')
        } else {
          //判断是否选择了不同项目的人员
          let name = this.multipleEleSelection[0].StrprojectName;
          let hasDifferent = this.multipleEleSelection.some(val => val.StrprojectName != name)
          if (hasDifferent) {
            this.$message.warning('请选择同项目的人员')
          } else {
            this.clearEleForm();
            this.templatesByProjectList();
            let list = []
            this.multipleEleSelection.forEach((element, index) => {
              let data = {
                name: element.strEmpName,
                StrObjName: element.strObjName,
                JobName: element.strJobInf,
                DtEntryBdate: element.dtEntryBdate,
                PhoneNum: element.strPhoneNum,
                StrIdCard: element.strIdCard,
                EmergencyPhone: element.strContTel,
                EmergencyContact: element.strContName,
                StrEduLvl: '',
                Bankcard: element.strBankCard,
                DepositBank: element.strBankName,
                EmpContactAddress: element.strNativeAddr, //户籍地址
                StrDep: '', //部门
                TrialPeriodDec: '', ///试用期工资 金额
                StrReasonzh: '', //暂缓缴纳原因
                SubsidyAmount: '', //补贴金额
                SubsidyInstru: '',
                WorkingDay: '',
                StrPsnEmail: '', //个人电子邮箱
                StrPsnWx: '', //个人微信号
                StrPsnQq: '', //个人QQ
                StrEmContact: '', //紧急联系人
                StrEmContactPhone: '', //紧急联系人电话
                StrEmContactEmail: '', //紧急联系人邮箱
                StrEmContactAddr: '', //紧急联系人地址
                StrInterDurMonths: '', //月岗位工资
                StrReasonLeaving: '', //月绩效工资
                StrWorkHours: '', //税前基本工资
                StrInterDurMonths: '', //税前月岗位津贴
                LegalFeesAmountWords: '',
                LegalFeesAmount: '',
                ConfiPeriod: '',
              }
              list.push(data)
              if (this.multipleEleSelection.length == index + 1) {
                this.$set(this.eleForm, 'list', list);
                // console.log(this.eleForm.list)
                this.eleForm.ObjName = this.multipleEleSelection[0].StrprojectName
              }
            });
            this.showEleInfo = true;
          }
        }
      },
      // 未在保分页
      underCurrentChange(val) {
        this.underQuery.pagination.page = Number(val)
        this.getList()
      },
      underSizeChange(val) {
        this.underQuery.pagination.page = 1
        this.underQuery.pagination.pageSize = Number(val)
        this.getList()
      },
      // 获取列表
      getList() {
        this.tableLoading = true
        xz.rcFun(this.underQuery, 'InterviewOnboarding/GetEmployeeList').then(res => {
          // console.log('getList', res)
          if (res.status == 'ok') {
            this.notUnderData = res.data.data
            this.underTotal = res.data.totalCount
          } else {
            this.notUnderData = []
            this.underTotal = 0
          }
          this.tableLoading = false
        })
      },
      expList() {
        let data = JSON.parse(JSON.stringify(this.underQuery));
        data.isExp = '1';
        // data.perpage = 100000;
        this.isBtnLoading = true;
        if (this.multipleEleSelection.length > 0) {
          let arr = [];
          this.multipleEleSelection.forEach(e => {
            arr.push(e.StrIdCard)
          });
          let stroutid = arr.toString();
          data.stroutid = stroutid;
        }
        xz.expGetsignResumeListsonworkInsu(data).then(res => {
          if (res) {
            let url = res;
            let base64 = url.toString()
            let byteCharacters = atob(
              base64.replace(/^data:image\/(png|jpeg|jpg);base64,/, "")
            )
            let byteNumbers = new Array(byteCharacters.length)
            for (let i = 0; i < byteCharacters.length; i++) {
              byteNumbers[i] = byteCharacters.charCodeAt(i)
            }
            let byteArray = new Uint8Array(byteNumbers)
            let blob = new Blob([byteArray], {
              type: `application/pdf`
            })
            let aLink = document.createElement("a")
            aLink.download = '在职未签约列表.xls' //这里写保存时的图片名称
            aLink.href = URL.createObjectURL(blob)
            aLink.click()
            this.isBtnLoading = false;
          } else {
            this.$message.error('导出失败')
            this.isBtnLoading = false;
          }
        })
      },
      expAllList() {
        let data = JSON.parse(JSON.stringify(this.underQuery));
        data.isExp = '1';
        data.perpage = 100000;
        this.isBtnAllLoading = true;
        xz.InEmpSignExcel(data, this.roletype).then(res => {
          if (res.status == "ok") {
            let url = res.data;
            let base64 = url.toString()
            let byteCharacters = atob(
              base64.replace(/^data:image\/(png|jpeg|jpg);base64,/, "")
            )
            let byteNumbers = new Array(byteCharacters.length)
            for (let i = 0; i < byteCharacters.length; i++) {
              byteNumbers[i] = byteCharacters.charCodeAt(i)
            }
            let byteArray = new Uint8Array(byteNumbers)
            let blob = new Blob([byteArray], {
              type: `application/pdf`
            })
            let aLink = document.createElement("a")
            aLink.download = '全量在职未签约列表.xls' //这里写保存时的图片名称
            aLink.href = URL.createObjectURL(blob)
            aLink.click()
            this.isBtnAllLoading = false;
          } else {
            this.$message.error('导出失败')
            this.isBtnAllLoading = false;
          }
        })
      },
      // 多选
      underSelChange(val) {
        this.multipleEleSelection = val
        // this.underMultipleList = val
      },
      changeTab(tab) {
        this.actFirstName = tab.name
        this.listQuery.SignatureStatus = JSON.parse(JSON.stringify(tab.name))
        if (tab.name == 'first') {
          this.underQuery.pagination.page = 1
          this.getList()
        } else {
          this.listQuery.EmpSigningStartTime = '';
          this.listQuery.EmpSigninEndTime = '';
          this.listQuery.ApprovalStartTime = '';
          this.listQuery.IsOnline = 1;
          if (tab.name == '线下签约') {
            this.listQuery.SignatureStatus = '通过';
            this.listQuery.IsOnline = 0;
          } else if (tab.name == '待审批' || tab.name == '客服初审') {
            this.listQuery.IsEmpSignTimeAsc = '1';
            this.listQuery.IsContractCreateTimeAsc = '';
          } else if (tab.name == '待签字') {
            this.listQuery.IsEmpSignTimeAsc = '';
            this.listQuery.IsContractCreateTimeAsc = '1';
          } else {
            this.listQuery.IsContractCreateTimeAsc = '';
            this.listQuery.IsEmpSignTimeAsc = '';
          }
          this.getContractApproList();
        }
      },
      //获取合同审批列表
      getContractApproList() {
        this.loading = true;
        this.listQuery.IsExport = 0;
        this.tableData = [];
        xz.getContractApproList(this.listQuery, this.roletype).then(res => {
          if (res.status == 'ok') {
            this.tableData = res.data.data;
            this.totalCount = res.data.totalcount;
            this.initNum = 0; //发起签约数量
            this.signedNum = 0; //待签字数量
            this.approveNum = 0; //待审批数量
            this.firstApproveNum = 0;
            this.passNum = 0; //通过数量
            this.passNum2 = 0;
            this.notPassNum = 0; //不通过数量
            this.refuseNum = 0;
            this.overdueNum = 0;
            this.delNum = 0;
            this.offineNum = 0;
            if (res.data.collect.length > 0) {
              res.data.collect.forEach(element => {
                if (element.SignatureStatus == '发起签约') {
                  this.initNum = element.EntNum
                } else if (element.SignatureStatus == '待签字') {
                  this.signedNum = element.EntNum
                } else if (element.SignatureStatus == '客服初审') {
                  this.firstApproveNum = element.EntNum
                } else if (element.SignatureStatus == '待审批') {
                  this.approveNum = element.EntNum
                } else if (element.SignatureStatus == '通过') {
                  this.passNum = element.EntNum
                } else if (element.SignatureStatus == '已签约归档') {
                  this.passNum2 = element.EntNum
                } else if (element.SignatureStatus == '不通过') {
                  this.notPassNum = element.EntNum
                } else if (element.SignatureStatus == '拒签') {
                  this.refuseNum = element.EntNum
                } else if (element.SignatureStatus == '逾期未签署') {
                  this.overdueNum = element.EntNum
                } else if (element.SignatureStatus == '删除') {
                  this.delNum = element.EntNum
                } else if (element.SignatureStatus == '线下签约') {
                  this.offineNum = element.EntNum
                }
              });
            }
            this.loading = false;
          } else {
            this.tableData = [];
            this.totalCount = 0;
            this.$message.error('获取模板列表失败')
            this.loading = false;
          }
        })
      },
      currentChange(val) {
        this.listQuery.pageNum = Number(val);
        this.getContractApproList();
      },
      handleSizeChange(val) {
        console.log(`每页 ${val} 条`);
        this.listQuery.pageNum = 1;
        this.listQuery.pageSize = val;
        this.getContractApproList();
      },
      handleSelectionChange(val) {
        this.multipleSelection = val;
      },
      // 详情
      dtlHandle(item) {
        let routeUrl = this.$router.resolve({
          path: '/dtlResource',
          query: {
            id: item.ResumeId,
            pageTitle: '在职'
          }
        });
        window.open(routeUrl.href, '_blank');
      },
      //预览/下载合同
      downContract(row, type) {
        if (row.ContractId) {
          this.previewUrl = '';
          let name;
          if (row.ProtocolType == '其他') {
            name = row.ObjName + '-' + row.Name + '-' + row.TempName;
          } else if (row.ProtocolType && row.ProtocolType.indexOf('解除') > -1) {
            name = row.ObjName + '-' + row.Name + row.TempName;
          } else {
            name = row.ObjName + '-' + row.Name + row.TempName;
          }

          this.getBestSingndownloadfile(row.ContractId, name, type)
          if (type == 'preview') {
            this.showPreview = true;
            this.previewLoading = true;
          } else {
            this.expLoading = true;
          }
        } else {
          this.$message.error('暂无合同')
        }
      },
      contractView(row) {
        let d = {
          templateName: row.TempName
        }
        xz.GetContractPreview(d, this.roletype).then(res => {
          try {
            let url = res.content;
            let base64 = url.toString()
            let byteCharacters = atob(
              base64.replace(/^data:image\/(png|jpeg|jpg);base64,/, "")
            )
            let byteNumbers = new Array(byteCharacters.length)
            for (let i = 0; i < byteCharacters.length; i++) {
              byteNumbers[i] = byteCharacters.charCodeAt(i)
            }
            let byteArray = new Uint8Array(byteNumbers)
            let blob = new Blob([byteArray], {
              type: `application/pdf`
            })
            let url2 = URL.createObjectURL(blob);
            this.previewUrl = url2;
            this.showPreview = true;
          } catch (e) {
            this.$message.error('系统出错')
          }
        })
        // this.showPreview = true;
        // this.previewLoading = true;
      },
      contractView2(row) {
        this.loading = true;
        xz.ContractPreview(row.Id, this.roletype).then(res => {
          if (res.status == 'ok') {
            try {
              let url = res.data.base64;
              let base64 = url.toString()
              let byteCharacters = atob(
                base64.replace(/^data:image\/(png|jpeg|jpg);base64,/, "")
              )
              let byteNumbers = new Array(byteCharacters.length)
              for (let i = 0; i < byteCharacters.length; i++) {
                byteNumbers[i] = byteCharacters.charCodeAt(i)
              }
              let byteArray = new Uint8Array(byteNumbers)
              let blob = new Blob([byteArray], {
                type: `application/pdf`
              })
              let url2 = URL.createObjectURL(blob);
              this.previewUrl = url2;
              this.showPreview = true;
              this.loading = false;
            } catch (e) {
              this.$message.error('预览出错！')
              this.loading = false;
            }
          } else {
            this.$message.error(res.msg)
            this.loading = false;
          }
        })
      },
      //批量导出合同
      exportContract() {
        if (this.multipleSelection.length == 0) {
          this.$message.warning('请至少选择一位人员')
        } else {
          let noConId = this.multipleSelection.some(ele => !ele.ContractId)
          if (noConId) {
            this.$message.warning('请选择有合同的导出')
          } else {
            let id = '';
            this.multipleSelection.forEach((element, index) => {
              id = index == 0 ? element.ContractId : id + ',' + element.ContractId
              if (index + 1 == this.multipleSelection.length) {
                let name = ''
                if (this.multipleSelection.length == 1) {
                  name = '合同批量导出' + moment().format('YYYY-MM-DD HH:mm:ss');
                } else {
                  name = '合同批量导出' + moment().format('YYYY-MM-DD HH:mm:ss');
                }
                this.isBtnLoading = true;
                this.getBestSingndownloadfile(id, name, 'down')
              }
            });
          }
        }
      },
      getBestSingndownloadfile(id, name, type) {
        let data;
        if (type == 'down') {
          data = {
            id: id
          }
        } else {
          data = {
            id: id,
            preview: '1'
          }
        }
        xz.getBestSingndownloadfile(data, this.roletype).then(res => {
          if (res.status == 'ok') {
            this.isBtnLoading = false;
            // let d = res.data.replace("\"", "").replace("\"", "");
            // var path = this.headPath + d;
            // const aTag = document.createElement('a')
            // aTag.href = path;
            // aTag.setAttribute('download', name);
            // aTag.click();
            // this.expLoading = false;

            let url = res.data.base64;
            let base64 = url.toString()
            let byteCharacters = atob(
              base64.replace(/^data:image\/(png|jpeg|jpg);base64,/, "")
            )
            let byteNumbers = new Array(byteCharacters.length)
            for (let i = 0; i < byteCharacters.length; i++) {
              byteNumbers[i] = byteCharacters.charCodeAt(i)
            }
            let byteArray = new Uint8Array(byteNumbers)
            let blob = new Blob([byteArray], {
              type: `application/pdf`
            })
            if (type == 'down') {
              let aLink = document.createElement("a")
              aLink.download = name + res.data.type; //这里写保存时的文件名称
              aLink.href = URL.createObjectURL(blob)
              aLink.click()
              this.expLoading = false;
            } else {
              if (res.data.type == '.pdf') {
                this.currentPage = 1;
                let url = URL.createObjectURL(blob);
                this.previewUrl = url;
                // this.previewUrl = pdf.createLoadingTask({
                //   url: url,
                //   cMapUrl:'assets/cmaps/',
                //   // cMapUrl: 'https://unpkg.com/pdfjs-dist@2.0.943/cmaps/',
                //   cMapPacked: true,
                //   // CMapReaderFactory 
                // });
                // // this.previewUrl = pdf.createLoadingTask(url)
                // this.previewUrl.promise.then(pdf => {
                //   this.pageTotal = pdf.numPages
                // })
                // this.scrollbarReset();
                setTimeout(() => {
                  this.previewLoading = false;
                }, 500);
              } else {
                this.$message.warning('合同包含附件，不能预览，请下载查看')
                this.showPreview = false;
                this.previewLoading = false;
              }
            }
          } else {
            this.$message.error('系统出错')
            this.expLoading = false;
            this.isBtnLoading = false;
            this.previewLoading = false;
          }
        })
      },
      review() {
        xz.getTempCombined(this.shangTempId, this.roletype).then(res => {
          if (res.status == 'ok') {
            let url = res.data.content;
            let base64 = url.toString()
            let byteCharacters = atob(
              base64.replace(/^data:image\/(png|jpeg|jpg);base64,/, "")
            )
            let byteNumbers = new Array(byteCharacters.length)
            for (let i = 0; i < byteCharacters.length; i++) {
              byteNumbers[i] = byteCharacters.charCodeAt(i)
            }
            let byteArray = new Uint8Array(byteNumbers)
            let blob = new Blob([byteArray], {
              type: `application/pdf`
            })
            this.currentPage = 1;
            this.previewUrl = URL.createObjectURL(blob);
            this.showPreview = true;
          } else {
            this.$message.error('获取合同失败')
          }
        })
      },
      //批量导入选择模板
      changeTemp(val) {
        this.tempName = val.TempName;
        this.importForm.tempid = val.TempId;
        this.shangTempId = val.shangTempId;
      },
      //批量导入选择模板
      changeTemp2(val) {
        console.log(val)
        this.tempName = val.TempName;
        this.eleForm.tempid = val.TempId;
        this.shangTempId = val.shangTempId;
      },
      //单笔签约选择模板
      changeTempSingle(val) {
        this.tempNameSingle = val.TempName;
        this.signingForm.tempid = val.TempId;
        this.shangTempId = val.shangTempId;
      },
      //发送短信
      sendMessage(type) {
        if (type == 'all') {
          this.visibleSendAll = false;
          this.messageIds = '';
          if (this.totalCount == 0) {
            this.$message.warning('暂无人员')
          } else {
            this.confirmSend();
          }
        } else {
          if (this.multipleSelection.length == 0) {
            this.$message.warning('请至少选择一位人员')
          } else {
            this.showSendMessage = true;
            this.messageIds = '';
            this.multipleSelection.forEach((element, index) => {
              if (index == 0) {
                this.messageIds = element.Id
              } else {
                this.messageIds = this.messageIds + ',' + element.Id
              }
            });
          }
        }
      },
      //确认发送短信
      confirmSend() {
        this.loading = true;
        let data = null;
        if (this.messageIds == '') { //全员发送
          data = this.listQuery;
          this.$set(data, 'ids', '');
          this.$set(data, 'IsExport', '0');
          data.pageNum = 1;
          data.pageSize = 10000;
        } else {
          data = {
            ids: this.messageIds
          };
        }
        this.progress = '';
        if (this.listQuery.SignatureStatus == '发起签约' || this.listQuery.SignatureStatus == '逾期未签署' || this.listQuery.SignatureStatus == '拒签') {
          xz.sendtextMessagesContracts(data, this.roletype).then(res => {
            if (res.status == 'ok') {
              if (res.data != undefined && res.data) {
                this.progress = 0;
                this.progresId = res.data;
                this.interval = setInterval(this.getAsyncBatchSendProgress, 5000)
              } else {
                this.progress = '';
                this.$message.success('发送成功');
                this.getContractApproList();
                this.loading = false;
              }
            } else {
              this.$message.error(res.msg)
              this.loading = false;
            }
            this.showSendMessage = false;
          })
        } else {
          xz.contractsRemind(data, this.roletype).then(res => {
            if (res.status == 'ok') {
              this.$message.success('发送成功');
              this.getContractApproList();
              this.loading = false;
            } else {
              this.$message.error(res.msg)
              this.loading = false;
            }
            this.showSendMessage = false;
          })
        }
      },
      //获取批量发送短信进度
      getAsyncBatchSendProgress() {
        xz.getAsyncBatchSendProgress(this.progresId, this.roletype).then(res => {
          if (res.status == 'ok') {
            if (res.data.currentNum == res.data.total) {
              clearInterval(this.interval)
              this.progress = '';
              this.loading = false;
              this.$message.success(res.data.msg)
            }
            this.progress = (res.data.currentNum / res.data.total * 100).toFixed(0);
            console.log(this.progress)
          }
        })
      },
      //批量删除
      batchDel() {
        if (this.multipleSelection.length == 0) {
          this.$message.warning('请至少选择一位人员')
        } else {
          this.DeleteReason = '';
          this.showBatchDel = true;
        }
      },
      // 获取项目列表
      getSearchJobProList() {
        let proNameQuery = {
          roletype: localStorage.loginRoletype,
          projectname: "",
          perpage: 10000,
          currpage: 1,
        };
        xz.getProjectLists(proNameQuery).then((res) => {
          if (res.status == "ok") {
            this.proList = res.msg;
          } else {
            this.proList = [];
          }
        });
      },
      changePro(val) {
        this.importForm.tempid = '';
        this.signingForm.tempid = ''
        if (val) {
          xz.templatesByProjectList(val, this.roletype).then(res => {
            if (res.status == 'ok') {
              this.tempList = res.data.tempList;
            } else {
              this.$message.error(res.msg)
            }
          })
        }
      },
      //导入签约表
      importSigning() {
        this.importForm = {
          url: '',
          ContractSubject: '', //主体
          tempid: '',
          ObjName: '',
          ContractSubject: '', //签约主体
          LegalPer: '', //法人
          RegisterAddress: '', //注册地址
          TaxNum: '',
          ProtocolType: '', //合同/协议类型
        }
        this.ExcelSrc = {
          value: "",
          check: false,
          fileName: "",
        }
        this.tempName = '';
        this.shangTempId = '';
        console.log(this.$refs['upload'])
        this.no = '';
        this.showImport = true;
        if (this.$refs['upload'] != undefined) {
          this.$refs['upload'].value = null;
        }
      },
      //下载导入模板
      downImportTemp() {
        if (!this.importForm.ProtocolType) {
          this.$message.warning('请先选择合同/协议类型！')
        } else {
          xz.getImportSigningTableTemplate(this.importForm.ProtocolType, this.roletype).then(res => {
            if (res.status == 'ok') {
              let name;
              if (this.importForm.ProtocolType == '其他') {
                name = this.importForm.ProtocolType + '导入签约表模板';
              } else {
                name = this.importForm.ObjName + '-' + this.importForm.ProtocolType + '导入签约表模板';
              }
              var path = this.$store.state.EMP.tablePath + res.data;
              const aTag = document.createElement('a')
              aTag.href = path
              aTag.setAttribute('download', name + '.xls');
              aTag.click();
            } else {
              this.$message.error('获取模板失败')
            }
          })
        }

      },
      //文件读取
      async importf() {
        const fileInput = this.$refs.upload;
        FUN.returnExcelSrc(fileInput).then((src) => {
          if (src) {
            this.$set(this.ExcelSrc, "value", src.src);
            this.$set(this.ExcelSrc, "check", false);
            this.$set(this.ExcelSrc, "fileName", fileInput.files[0].name);
            // console.log('srccc', this.ExcelSrc)
            //上传excel
            const excelFile = FUN.base64ToFile(
              this.ExcelSrc.value,
              this.ExcelSrc.fileName
            );
            const formData = new FormData();
            formData.append("pagename", "empexcel");
            formData.append("action", "save");
            formData.append("userid", Cookies.get("userid-b"));
            formData.append("entid", this.entid);
            formData.append("excel", excelFile, this.ExcelSrc.fileName);
            console.log("formData", formData);
            xz.uploadCert(formData).then((res) => {
              if (this.isNull(res) || res == false) {
                this.$message("上传Excel失败!");
                this.isUploadSuccess = false;
                this.$refs['upload'].value = null;
              } else {
                this.isUploadSuccess = true;
                this.importForm.url = res;
              }
            });
          } else {
            this.$message("上传Excel失败!");
            this.isUploadSuccess = false;
            this.$refs['upload'].value = null;
          }
        });
      },
      //确认导入excel
      confirmImport() {
        this.$refs.importForm.validate((valid) => {
          if (valid) {
            this.impLoading = true;
            xz.batchImportQuery(this.importForm, this.roletype).then(res => {
              if (res.status == 'ok') {
                this.$message.success('导入成功！');
                this.getContractApproList();
                this.impLoading = false;
                this.showImport = false;
              } else if (res.status == 'Resubmit') {
                this.submitMsg = res.msg
                this.showResubmit = true;
              } else {
                this.$message.error(res.msg)
                this.impLoading = false;
                this.ExcelSrc = {
                  value: "",
                  check: false,
                  fileName: "",
                }
              }
            })
          }
        })
        // console.log(this.importForm)
      },
      //单笔签约
      signing() {
        this.tempNameSingle = '';
        this.shangTempId = '';
        this.no = '';
        this.signingForm = this.$options.data.call(this).signingForm;
        this.showSigning = true;
      },
      //单人发送短信
      singleSendMessage(row) {
        if (!this.loading) {
          this.messageIds = row.Id;
          this.confirmSend();
        }
      },
      delHandle(row) {
        this.delForm.id = row.Id
        this.delForm.DeleteReason = '';
        this.showDeleteReason = true;
      },
      //删除
      confirmDel() {
        this.isBtnLoading = true;
        xz.delContractAppro([this.delForm], this.roletype).then(res => {
          if (res.status == 'ok') {
            this.$message.success('删除成功！')
            this.getContractApproList();
            this.isBtnLoading = false;
            this.showDeleteReason = false;
          } else {
            this.$message.error('系统出错')
            this.isBtnLoading = false;
          }
        })
      },
      //审批
      // inspect(row) {
      //   this.info = row;
      //   this.showInspect = true;
      // },
      //驳回
      reject(row) {
        this.info = row;
        this.showReject = true;
      },
      //审批通过/不通过
      pass(row, ResultApproval) {
        this.loading = true;
        let data = {
          ids: row.Id,
          ReturnReasons: this.ReturnReasons,
          ResultApproval
        }
        xz.contracttApproval(data, this.roletype).then(res => {
          if (res.status == 'ok') {
            this.$message.success('保存成功！')
            this.loading = false;
            this.showInspect = false;
            this.showReject = false;
            this.getContractApproList();
          } else {
            this.loading = false;
            this.showReject = false;
            // this.$message.error(res.msg)
            this.$message({
              message: res.msg,
              type: 'error',
              duration: 5000
            });
          }
        })
      },
      //导出列表
      exportList() {
        this.loading = true;
        this.listQuery.IsExport = 1;
        let ps = this.listQuery.pageSize;
        if (this.listQuery.pageSize <= this.multipleSelection.length) {
          this.listQuery.pageSize = 100000;
        }
        xz.getContractApproList(this.listQuery, this.roletype).then(res => {
          if (res.status == 'ok') {
            let url = res.data;
            let base64 = url.toString()
            let byteCharacters = atob(
              base64.replace(/^data:image\/(png|jpeg|jpg);base64,/, "")
            )
            let byteNumbers = new Array(byteCharacters.length)
            for (let i = 0; i < byteCharacters.length; i++) {
              byteNumbers[i] = byteCharacters.charCodeAt(i)
            }
            let byteArray = new Uint8Array(byteNumbers)
            let blob = new Blob([byteArray], {
              type: `application/pdf`
            })
            let aLink = document.createElement("a")
            aLink.download = this.listQuery.ObjName + this.listQuery.SignatureStatus + '.xls' //这里写保存时的图片名称
            aLink.href = URL.createObjectURL(blob)
            aLink.click()
            this.listQuery.pageSize = ps;
            this.loading = false;
          } else {
            this.listQuery.pageSize = ps;
            this.$message.error('导出失败')
            this.loading = false;
          }
        })
      },
      //选择主体
      changeLeg(val, list) {
        if (val) {
          xz.getLegalSubjec(val).then(res => {
            if (res.status == 'ok') {
              this.$set(this[list], 'LegalPer', res.data.LegalPerson)
              this.$set(this[list], 'RegisterAddress', res.data.RegisteredAddress.indexOf('$$') > -1 ? res.data.RegisteredAddress.replace('$$', '') : res.data.RegisteredAddress)
              this.$set(this[list], 'TaxNum', res.data.TaxNum)
            } else {
              this.$message.error('获取主体信息出错')
            }
          })
        } else {
          this.$set(this[list], 'LegalPer', '')
          this.$set(this[list], 'RegisterAddress', '')
        }
      },
      //限制input输入类型
      limitInput(val, type, item, form) {
        if (val >= 10000) {
          this.$message.warning(type + '不能超过1万');
          this.$nextTick(() => {
            this[form][item] = undefined
          })
        }
      },
      confirmSign() {
        this.$refs.signingForm.validate((valid) => {
          if (valid) {
            xz.submitESigningInfo(this.signingForm, this.roletype).then(res => {
              if (res.status == 'ok') {
                this.$message.success('保存成功！')
                this.getList()
                this.showEleInfo = false;
                this.multipleEleSelection = []
                this.showSigning = false;
              } else if (res.status == 'Resubmit') {
                this.submitMsg = res.msg
                this.showResubmit = true;
              } else {
                this.$message.error(res.msg)
              }

            })
          }
        })
      },
      //确认批量删除
      confirmBatchDel() {
        this.isBtnLoading = true
        let arr = [];
        this.multipleSelection.forEach(e => {
          let d = {
            id: e.Id,
            DeleteReason: this.DeleteReason
          }
          arr.push(d)
        });
        xz.delContractAppro(arr, this.roletype).then(res => {
          if (res.status == 'ok') {
            this.isBtnLoading = false;
            this.$message.success('作废成功！');
            this.getContractApproList();
          } else {
            this.$message.error('系统出错')
          }
          this.showBatchDel = false;
        })
      },
      getEndDate(list) {
        this[list].TrialMonth = Number(this[list].TrialMonth)
        if (this[list].TrialMonth > 0 && Number.isInteger(this[list].TrialMonth)) {
          this[list].TrialPeriodEndTime = moment(this[list].TrialPeriodStartTime).add(this[list].TrialMonth, 'months').format('YYYY-MM-DD');
          this[list].TrialPeriodEndTime = moment(this[list].TrialPeriodEndTime).subtract(1, 'days').format('YYYY-MM-DD');
        }
        if (this[list].TrialMonth > 6) {
          this.$message.warning('当前试用期已超过6个月，请核对！');
        }
        // else {
        //   this[list].TrialPeriodEndTime = this[list].TrialPeriodStartTime
        // }
      },
      getContractEndDate(val, list) {
        if (val >= 1) {
          if (this.no == 30 || this.no == 33) {
            this[list].ContractEndTime = moment(this[list].ContractStartTime).add(val, 'months').format('YYYY-MM-DD');
          } else {
            this[list].ContractEndTime = moment(this[list].ContractStartTime).add(val, 'years').format('YYYY-MM-DD');
          }
          this[list].ContractEndTime = moment(this[list].ContractEndTime).subtract(1, 'days').format('YYYY-MM-DD');
        }
      },
      //选择合同/协议
      changeCont(val, list) {
        // this.$refs.signingForm.validate();
        this[list].ProtocolType = val.name;
        this.contractType = val.val;
        this.jobNameLabel = val.jobNameLabel;
        this.no = val.no;
      },
      changeNo(val) {
        this.importForm.ProtocolType = val.name;
        this.no = val.no;
      },
      // 获取到pdf总页数时触发 会传入总页数
      getTotalPage(page) {
        this.pageTotal = page
      },
      chengPage(type) {
        // 防抖 0.5秒内不再次触发时执行
        if (this.pageChangeTimer) {
          clearTimeout(this.pageChangeTimer)
        }
        // 执行翻页
        this.pageChangeTimer = setTimeout(() => {
          if (type === '+') {
            this.currentPage += 1
          } else {
            this.currentPage -= 1
          }
          // 翻页后将滚动条归位到顶部
          // this.scrollbarReset()
          this.pageChangeTimer = null
        }, 500)
      },
      // 方法 滚动条归位到顶部
      scrollbarReset() {
        let boxDom = document.querySelector('.preview_box')
        boxDom.scrollTop = 0
      },
      disabledDate(time) {
        return (time.getTime() < new Date(this.mon1).getTime() || time.getTime() > new Date().getTime())
      },
      changeEmpSigningStartTime() {
        this.listQuery.EmpSigninEndTime = this.listQuery.EmpSigningStartTime
      },
      changeApprovalStartTime() {
        this.listQuery.ApprovalEndTTime = this.listQuery.ApprovalStartTime
      },
      resetHandle() {
        this.listQuery = {
          SignatureStatus: this.listQuery.SignatureStatus,
          ProjectName: '',
          ApproResult: '',
          Name: '',
          PhoneNum: '',
          ContractSubject: '', //主体名称
          ObjName: '', //项目名称
          TempType: '', //合同类型
          tempName: '', //合同名称
          ContractId: '', //合同编号
          EmpSigningStartTime: '', //员工签署开始时间
          EmpSigninEndTime: '', //员工签署结束时间
          ApprovalStartTime: '', //盖章开始时间
          ApprovalEndTTime: '', //盖章结束时间
          Remark1: '',
          Remark2: '',
          Remark3: '',
          pageNum: 1,
          pageSize: 10,
          IsExport: 0, //0查询列表  1导出
        }
      },
      //计算工作时长
      changeTimeLaborContract(list, val) {
        if (!this.isNull(this[list].list[0].DtEntryBdate)) {
          let m1 = this[list].list[0].DtEntryBdate + ' 00:00:00';
          let m2 = this[list].TimeLaborContract + ' 00:00:00';
          let diff = moment.preciseDiff(m1, m2, true);
          console.log(diff)
          this[list].WorkingYear = diff.years;
          this[list].WorkingMonth = diff.months;
          this[list].WorkingDay = diff.days + 1;
        }
        this[list].TimeLaborContractStaff = val
      },
      //客服初审
      firstInspect(row) {
        let d = {
          work: 1,
          ids: row.Id
        }
        xz.customerServiceApproved(d, this.roletype).then(res => {
          if (res.status == 'ok') {
            this.$message.success('保存成功！')
            this.loading = false;
            this.showInspect = false;
            this.getContractApproList();
          } else {
            this.loading = false;
            this.$message.error('系统出错')
          }
        })
      },
      //修改手机号码
      editPhone(row) {
        this.phoneName = row.Name;
        this.phoneForm = {
          id: row.Id,
          Phone: row.PhoneNum,
          EmpContactAddress: row.EmpContactAddress,
          StrEduLvl: row.StrEduLvl,
        }
        this.showEditPhone = true;
      },
      confirmEditPhone() {
        if (!this.phoneForm.Phone) {
          this.$message.warning('请填写手机号')
        } else {
          xz.modifyMobilePhone(this.phoneForm, this.roletype).then(res => {
            if (res.status == 'ok') {
              this.$message.success('修改成功！')
              this.showEditPhone = false;
              this.getContractApproList();
            } else {
              this.showEditPhone = false;
              this.$message.error('系统出错')
            }
          })
        }
      },
      //导出项目签约汇总
      exportProSum() {
        this.showExportProSum = true;
      },
      //确认导出项目签约汇总
      confirmExportProSum() {
        if (!this.proSumMonth) {
          this.$message.warning('请选择月份')
        } else {
          xz.getMonthlyEconSummary(this.proSumMonth, this.roletype).then(res => {
            if (res.status == 'ok') {
              let url = res.data;
              let base64 = url.toString()
              let byteCharacters = atob(
                base64.replace(/^data:image\/(png|jpeg|jpg);base64,/, "")
              )
              let byteNumbers = new Array(byteCharacters.length)
              for (let i = 0; i < byteCharacters.length; i++) {
                byteNumbers[i] = byteCharacters.charCodeAt(i)
              }
              let byteArray = new Uint8Array(byteNumbers)
              let blob = new Blob([byteArray], {
                type: `application/pdf`
              })
              let aLink = document.createElement("a");
              aLink.download = '项目签约汇总 - ' + this.proSumMonth + '.xls' //这里写保存时的名称
              aLink.href = URL.createObjectURL(blob)
              aLink.click()
              this.showExportProSum = false;
            } else {
              this.$message.error('导出失败')
              this.showExportProSum = false;
            }
          })
        }
      },
      //上传附件
      success_handle(file, fileList) {
        console.log(file, fileList);
        const formData = new FormData();
        formData.append("pagename", "docinf");
        formData.append("action", "save");
        formData.append("userid", Cookies.get("userid-b"));
        formData.append("entid", Cookies.get("userid-b"));
        formData.append("excel", file.raw, file.name);
        console.log("formData", formData);
        xz.uploadCert(formData).then((res) => {
          if (res) {
            this.offRegForm.AttachUrl = res
          } else {
            this.offRegForm.AttachUrl = ''
          }
        });
      },
      handleRemove(file) {
        this.offRegForm.AttachUrl = ''
      },
      handleExceed() {
        this.$message.warning(`当前限制最多上传 1 个文件`);
      },
      OfflineSigning(row) {
        this.offRegForm = {
          Id: '',
          Name: row.strEmpName,
          PhoneNum: row.strPhoneNum,
          StrObjName: row.strObjName, //项目名称
          StrIdCard: row.strIdCard, //身份证
          TempType: '用工协议', //签约类型
          ContractSubject: '', //员工签约主体
          SignatureTime: '', //合同签约时间
          ContractStartTime: '', //合同开始时间
          ContractEndTime: '', //合同结束时间
          dtEntryBDate: row.dtEntryBDate, //入职日期
          AttachUrl: '', //合同附件
        }
        this.isBtnLoading = false;
        this.fileList = [];
        this.showOfflineSigning = true;
      },
      confirmOfflineSigning() {
        this.$refs["offRegForm"].validate((valid) => {
          if (valid) {
            this.isBtnLoading = true;
            xz.addOfflineSigning(this.offRegForm, this.roleType).then(res => {
              if (res.status == 'ok') {
                this.$message.success('线下签约登记成功！');
                this.isBtnLoading = false;
                this.showOfflineSigning = false;
                this.getList();
              } else {
                this.$message.error(res.msg)
                this.isBtnLoading = false;
                this.showOfflineSigning = false;
              }
            })
          }
        })
      },
      //批量线下签约
      batchOfflineSigning() {
        if (this.multipleEleSelection.length == 0) {
          this.$message.warning('请至少选择一位人员')
        } else {
          let list = [];
          this.multipleEleSelection.forEach((element, index) => {
            let d = {
              Id: '',
              Name: element.strEmpName,
              PhoneNum: element.strPhoneNum,
              StrObjName: element.strObjName, //项目名称
              StrIdCard: element.strIdCard, //身份证
              TempType: '用工协议', //签约类型
              ContractSubject: '', //员工签约主体
              SignatureTime: '', //合同签约时间
              ContractStartTime: '', //合同开始时间
              ContractEndTime: '', //合同结束时间
              dtEntryBDate: element.dtEntryBDate, //入职日期
              AttachUrl: '', //合同附件
            }
            list.push(d);
          })
          this.offlineList = list;
          this.batchOff = this.$options.data.call(this).batchOff;
          this.showBatchOfflineSigning = true;
        }
      },
      confirmBatchOfflineSigning() {
        this.isBtnLoading = true;
        xz.AddOfflineSigningList(this.offlineList, this.roleType).then(res => {
          if (res.status == 'ok') {
            this.$message.success('保存成功！');
            this.isBtnLoading = false;
            this.showBatchOfflineSigning = false;
            this.getList();
          } else {
            this.$message.error(res.msg)
            this.isBtnLoading = false;
          }
        })
      },
      getContractTime(row) {
        let m1 = moment(row.ContractEndTime);
        let m2 = moment(row.ContractStartTime).subtract(1, 'days');
        let diff = moment.preciseDiff(m1, m2, true);
        let str = diff.years + '年';
        if (diff.months) {
          str = str + diff.months + '月'
        }
        if (diff.days) {
          str = str + diff.days + '天'
        }
        this.$set(row, 'diffYear', diff.years)
        return str;
      },
      batchPlacefileContracts() {
        if (this.multipleSelection.length > 0) {
          let arr = [];
          this.multipleSelection.forEach(e => {
            arr.push(e.Id)
          });
          let ids = arr.join(',');
          this.placefileContracts(ids);
        } else {
          this.$message.warning('请选择要归档的数据！')
        }
      },
      //归档
      placefileContracts(ids) {
        this.loading = true;
        let d = {
          ids
        }
        xz.placefileContracts(d).then(res => {
          if (res.status == 'ok') {
            this.loading = false;
            this.$message.success('操作成功！');
            this.getContractApproList();
          } else {
            this.loading = false;
            this.$message.error(res.msg)
            this.getContractApproList();
          }
        })
      },
      downOffineContract(row) {
        let url = this.$store.state.EMP.docPath + row.AttachUrl;
        let aLink = document.createElement("a")
        // aLink.download = name + res.data.type; //这里写保存时的文件名称
        aLink.href = url;
        aLink.click()
      },
      getContTime(val, list) {
        if (val.length == 18 && (this.no == 16 || this.no == 20 || this.no == 21 || this.no == 24 || this.no == 26 || this.no == 27 || this.no == 28 || this.no == 29)) {
          let str = `?strIdCard=${val}`
          xz.ArdCurStatGetFun('GetNewContractTimebyCardId', str).then(res => {
            if (res.status == 'ok') {
              try {
                this[list].ContractStartTime = res.data.dtContractBtime;
                if (this.no != 26) {
                  this[list].ContractEndTime = res.data.dtContractTime;
                }
              } catch (e) {}
            }
          })
        }
      },
      modelManage() {
        let routeUrl = this.$router.resolve({
          path: '/eleModelManage'
        });
        window.open(routeUrl.href, '_blank');
      },
      //批量签约主体
      batchContractSubject(val) {
        this.offlineList.forEach(e => {
          e.ContractSubject = val;
        })
      },
      batchProtocolType(val) {
        this.offlineList.forEach(e => {
          e.ProtocolType = val;
        })
      },
      batchdtEntryBDate(val) {
        this.offlineList.forEach(e => {
          e.dtEntryBDate = val;
        })
      },
      batchSignatureTime(val) {
        this.offlineList.forEach(e => {
          e.SignatureTime = val;
        })
      },
      batchContractStartTime(val) {
        this.offlineList.forEach(e => {
          e.ContractStartTime = val;
        })
      },
      batchContractEndTime(val) {
        this.offlineList.forEach(e => {
          e.ContractEndTime = val;
        })
      },
    }
  };
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .s_tabs_box {
    padding: 0 20px;
    box-sizing: border-box;
  }

  .r_dropDownScreen {
    width: 100%;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    background-color: #fff;
  }

  .re_down_form .el-form-item {
    margin-bottom: 3px;
    margin-right: 0;
  }

  .scr_icon.i_txt {
    display: inline-block;
    font-size: 12px;
    cursor: pointer;
  }

  .ftabs {
    background: #fff;
    padding: 10px 16px 16px;
    margin-bottom: 16px;
  }

  .qrcode_img02 {
    width: 20px;
    height: 20px;
  }

  .addNewTemp {
    line-height: 32px;
    margin-left: 30px;
    color: #598DE7;
  }

  /* 这是原生的input框，给他透明隐藏，然后定位让文件上传的按钮覆盖它 */
  #fileInput {
    width: 120px;
    margin-left: 8px;
    filter: Alpha(opacity=0);
    -moz-opacity: 0;
    opacity: 0;
    position: absolute;
    right: 37px;
    z-index: 2;
  }

  .file-box {
    position: relative;
    display: flex;
    align-items: center;
  }

  .file-box input {
    width: 400px;
    height: 40px;
    line-height: 40px;
    border: 1px solid #cccccc;
    padding-left: 14px;
    box-sizing: border-box;
    border-radius: 4px;
    border: 1px solid #DCDFE6;
  }

  .file-btn {
    display: inline-block;
    width: 54px;
    height: 28px;
    background: #fff;
    border: 1px solid #ccc;
    border-radius: 4px;
    text-align: center !important;
    line-height: 28px;
    color: #333333;
    margin-left: 8px;
    margin-top: 4px;
  }

  /* 单行文字截断，展示文件名的input框用的 */
  #applyLicense {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .inspectItem {
    width: 145px;
  }

  .inspect_foot {
    display: flex;
    justify-content: space-around;
    margin-top: 20px;
  }

  .page {
    display: flex;
    justify-content: flex-end;
    padding-right: 50px;
  }

  .preview_box {
    height: 80vh;
    overflow: auto;
  }

  .tips {
    margin-left: 30px;
    font-size: 14px;
    padding-bottom: 3px;
    color: red;
  }
</style>
<style>
  .page_eleSigning .el-table .ascending .sort-caret.ascending {
    border-bottom-color: #c0c4cc;
  }

  .page_eleSigning .el-table .descending .sort-caret.descending {
    border-top-color: #c0c4cc;
  }

  .page_eleSigning .th_input_label .el-form-item__label {
    width: 66px !important;
  }

  .page_eleSigning .el-form-item__label {
    padding: 0 5px 0 0;
  }

  .page_eleSigning .el-tabs {
    background-color: #fff;
  }

  .page_eleSigning .screenInputs .screenInput {
    margin: 0 0 10px 5px;
  }

  .page_eleSigning .screenInputs .screenInput .el-select .el-input__inner,
  .page_eleSigning .re_down_form.el-form--inline .el-form-item__content,
  .page_eleSigning .re_down_form .el-select,
  .page_eleSigning .re_down_form .el-form-item__content,
  .page_eleSigning .screenInput .el-input {
    width: 200px !important;
  }

  .page_eleSigning .ApprovalTime .el-form-item__content {
    width: 800px !important;
  }

  .page_eleSigning .ApprovalTime .el-input__inner {
    height: 32px;
    line-height: 32px;
    width: 200px;
  }

  .page_eleSigning .el-input__icon {
    height: 32px;
    line-height: 32px;
  }

  .page_eleSigning .ApprovalTime .el-date-editor.el-input,
  .el-date-editor.el-input__inner {
    width: 200px;
  }

  .page_eleSigning .doc_table .el-table__body td.el-table__cell,
  .page_eleSigning .re_table .el-table__body td.el-table__cell {
    padding: 5px 0;
  }

  .page_eleSigning .doc_table .el-table__body th.el-table__cell {
    padding: 8px 0;
  }

  .page_eleSigning .inspect .el-form-item {
    margin-bottom: 0
  }

  .page_eleSigning .eleForm .el-input-number__increase,
  .page_eleSigning .eleForm .el-input-number__decrease {
    display: none;
  }

  .page_eleSigning .eleForm .el-input-number .el-input__inner {
    padding-left: 15px;
    padding-right: 15px;
    text-align: left;
  }

  .page_eleSigning .eleForm .el-input-number {
    width: 200px;
  }

  .page_eleSigning .eleForm .el-input__icon {
    height: 32px;
  }

  .page_eleSigning .eleForm .el-form-item {
    margin-bottom: 10px;
  }

  .page_eleSigning .eleForm .el-form-item__error {
    top: 34px;
  }

  .page_eleSigning .eleTabBtn .el-button--text {
    color: #19bd92;
    font-size: 13px;
    padding: 0;
  }
</style>